/**
 * Spanish (es) - Traducciones completas
 */
export default {
  // Navigation
  dashboard: 'Dashboard',
  employees: 'Empleados',
  shifts: 'Turnos',
  schedule: 'Horario',
  reports: 'Reportes',
  settings: 'Configuración',
  notifications: 'Notificaciones',
  logout: 'Cerrar sesión',
  crm: 'CRM',
  erp: 'ERP',
  analytics: 'Analítica',
  domains: 'Dominios',
  integrations: 'Integraciones',
  templates: 'Plantillas',
  rules: 'Reglas',
  swaps: 'Intercambios',
  geofencing: 'Geocercas',
  aiScheduling: 'Programación con IA',
  locations: 'Ubicaciones',
  chat: 'Chat',
  leave: 'Permisos',
  vacations: 'Vacaciones',
  rewards: 'Recompensas',
  gamification: 'Gamificación',
  documents: 'Documentos',
  signatures: 'Firmas',
  predictions: 'Predicciones',
  aiPredictions: 'Predicciones de IA',
  whatsapp: 'WhatsApp',
  securityAlerts: 'Alertas de seguridad',
  compliance: 'Cumplimiento',
  mobileApp: 'Aplicación móvil',
  aiAutoAssign: 'Asignación automática con IA',

  // Auth
  login: 'Iniciar sesión',
  register: 'Registrarse',
  email: 'Correo electrónico',
  password: 'Contraseña',
  confirmPassword: 'Confirmar contraseña',
  firstName: 'Nombre',
  lastName: 'Apellido',
  phone: 'Teléfono',
  forgotPassword: '¿Olvidaste tu contraseña?',
  noAccount: '¿No tienes una cuenta?',
  haveAccount: '¿Ya tienes una cuenta?',
  twoFactorAuth: 'Autenticación de dos factores',
  enterCode: 'Introduce el código de tu aplicación de autenticación',
  verify: 'Verificar',

  // Dashboard
  welcome: 'Bienvenido',
  hello: 'Hola',
  yourSummaryToday: 'Tu resumen de hoy',
  organizationSummary: 'Resumen de tu organización',
  totalEmployees: 'Total de empleados',
  todaysShifts: 'Turnos de hoy',
  openShifts: 'Turnos abiertos',
  scheduledHours: 'Horas programadas',
  hoursThisWeek: 'Horas esta semana',
  upcomingShifts: 'Próximos turnos',
  quickActions: 'Acciones rápidas',
  addEmployee: 'Agregar empleado',
  createShift: 'Crear turno',
  viewSchedule: 'Ver horario',
  currentStreak: 'Racha actual',
  points: 'Puntos',
  level: 'Nivel',
  days: 'días',
  nextShift: 'Próximo turno',
  scheduledShift: 'Turno programado',
  clockInNow: 'Fichar ahora',
  viewAll: 'Ver todo',
  newShift: 'Nuevo turno',
  shiftsThisWeek: 'Turnos esta semana',
  totalHours: 'Total de horas',
  attendance: 'Asistencia',
  noShiftsToday: 'No hay turnos para hoy',
  viewReports: 'Ver reportes',
  alerts: 'Alertas',
  allSystemsOk: 'Todo funciona correctamente. No hay alertas importantes.',
  employee: 'Empleado',
  shift: 'Turno',
  pending: 'Pendiente',
  confirmed: 'Confirmado',
  of: 'de',
  sevenDays: '7 días',

  // Shifts Page
  manageAndScheduleShifts: 'Gestiona y programa turnos',
  noShiftsScheduledForDay: 'No hay turnos programados para este día',
  noShiftsScheduled: 'No hay turnos programados',
  notes: 'Notas',
  additionalNotes: 'Notas adicionales...',
  assigned: 'asignado',
  availableEmployees: 'Empleados disponibles',
  letAIOptimize: 'Deja que la IA optimice tu horario',
  fairDistribution: 'Distribución justa entre todos los empleados',
  minimizeCosts: 'Minimizar costos laborales',
  ensureFilled: 'Asegurar que todos los turnos estén cubiertos',
  aiOptimizing: 'La IA está optimizando...',
  more: 'más',
  day: 'Día',
  week: 'Semana',
  month: 'Mes',
  year: 'Año',
  list: 'Lista',
  partiallyFilled: 'Parcialmente cubierto',
  inProgress: 'En progreso',
  completed: 'Completado',
  cancelled: 'Cancelado',

  // Employees
  employeeList: 'Lista de empleados',
  addNewEmployee: 'Agregar nuevo empleado',
  searchEmployees: 'Buscar empleados...',
  role: 'Rol',
  certifications: 'Certificaciones',
  skills: 'Habilidades',
  hourlyRate: 'Tarifa por hora',
  maxHours: 'Máx. horas/semana',
  active: 'Activo',
  inactive: 'Inactivo',
  manageYourTeamMembers: 'Gestiona a los miembros de tu equipo',
  noEmployeesFound: 'No se encontraron empleados',
  addYourFirstEmployee: 'Agrega tu primer empleado',
  employeeHeader: 'Empleado',
  contact: 'Contacto',
  editEmployee: 'Editar empleado',
  failedToSaveEmployee: 'No se pudo guardar el empleado',
  deactivateEmployeeConfirm: '¿Estás seguro de que deseas desactivar a este empleado?',

  // Shifts
  shiftList: 'Lista de turnos',
  createNewShift: 'Crear nuevo turno',
  shiftTitle: 'Título del turno',
  startTime: 'Hora de inicio',
  endTime: 'Hora de fin',
  requiredEmployees: 'Empleados requeridos',
  assignedEmployees: 'Empleados asignados',
  assign: 'Asignar',
  unassign: 'Desasignar',
  status: 'Estado',
  open: 'Abierto',
  filled: 'Cubierto',

  // Time Tracking
  clockIn: 'Fichar entrada',
  clockOut: 'Fichar salida',
  timeTracking: 'Control de tiempo',

  // Organizations
  organization: 'Organización',
  createOrganization: 'Crear organización',
  organizationName: 'Nombre de la organización',
  subdomain: 'Subdominio',
  industry: 'Industria',
  timezone: 'Zona horaria',
  country: 'País',
  language: 'Idioma',
  branding: 'Marca',
  primaryColor: 'Color principal',
  secondaryColor: 'Color secundario',
  logo: 'Logo',

  // Plans
  subscription: 'Suscripción',
  currentPlan: 'Plan actual',
  upgradePlan: 'Actualizar plan',
  free: 'Gratis',
  pro: 'Profesional',
  enterprise: 'Empresarial',
  perMonth: '/mes',
  features: 'Funciones',
  subscriptionManagePlanAndBilling: 'Gestionar tu plan y facturación',
  subscriptionManageInStripe: 'Gestionar en Stripe',
  subscriptionStripeNotConfigured: 'Stripe no está configurado. Simularemos la suscripción activa.',
  subscriptionActivatedSuccessfully: '¡Suscripción activada correctamente!',
  subscriptionErrorProcessing: 'Error al procesar',
  subscriptionErrorOpeningPortal: 'Error al abrir el portal',
  subscriptionPlanUpgraded: 'Plan actualizado correctamente.',
  subscriptionPlanDowngraded: 'Plan degradado correctamente.',
  subscriptionProratedAmount: 'Importe prorrateado',
  subscriptionErrorChangingPlan: 'Error al cambiar el plan',
  subscriptionCancelledImmediately: 'Suscripción cancelada inmediatamente. El acceso a las funciones premium se ha deshabilitado.',
  subscriptionEndOfPeriod: 'fin del período',
  subscriptionScheduledForCancellation: 'Suscripción programada para cancelarse el {endDate}. Tu acceso continuará hasta entonces.',
  subscriptionErrorCancelling: 'Error al cancelar la suscripción',
  subscriptionStripeNotConfiguredTitle: 'Stripe no configurado',
  subscriptionStripeNotConfiguredDescription: 'Los pagos están en modo simulado. Configura las claves de la API de Stripe en',
  subscriptionIntegrations: 'Integraciones',
  subscriptionToActivateRealPayments: 'para activar los pagos reales.',
  subscriptionCurrentPlan: 'Plan actual',
  subscriptionCancellingNotice: 'Tu suscripción se cancelará al final del período actual. El acceso continuará hasta entonces.',
  subscriptionPerEmployee: 'empleado',
  subscriptionPerMonth: 'mes',
  subscriptionEmployees: 'empleados',
  subscriptionShiftsPerMonth: 'turnos/mes',
  subscriptionPlanComparison: 'Comparación de planes',
  subscriptionFeature: 'Función',
  subscriptionAdmins: 'Administradores',
  subscriptionAnalytics: 'Analíticas',
  subscriptionBasic: 'Básico',
  subscriptionAdvanced: 'Avanzado',
  subscriptionComplete: 'Completo',
  subscriptionWhiteLabel: 'Marca blanca',
  subscriptionSupport: 'Soporte',
  subscriptionSupportEmail: 'Correo electrónico',
  subscriptionSupportPriority: 'Prioritario',
  subscriptionSupport247: '24/7',
  subscriptionSupportDedicated: 'Dedicado',
  subscriptionReadyForProduction: 'Listo para AWS + Cloudflare',
  subscriptionProductionReadyDescription: 'Este sistema de suscripción está listo para producción. Configura tus claves reales de Stripe después del despliegue para procesar pagos. Los webhooks de Stripe deben apuntar a',
  subscriptionConfirmPlanChange: 'Confirmar cambio de plan',
  subscriptionPlanUpgrade: 'Actualización de plan',
  subscriptionPlanDowngrade: 'Degradación de plan',
  subscriptionPlanChange: 'Cambio de plan',
  subscriptionCurrentPlanLabel: 'Plan actual',
  subscriptionNewPlan: 'Nuevo plan',
  subscriptionRemainingDays: 'Días restantes en el período actual',
  subscriptionDays: 'días',
  subscriptionProratedCharge: 'Cargo prorrateado',
  subscriptionProratedCredit: 'Crédito prorrateado',
  subscriptionProratedChargeDescription: 'Se te cobrará este importe adicional por los días restantes del período actual. El nuevo plan se aplicará inmediatamente.',
  subscriptionProratedCreditDescription: 'Recibirás este crédito por los días restantes del período actual. El nuevo plan se aplicará inmediatamente.',
  subscriptionChangingFrom: 'Cambiando de',
  subscriptionTo: 'a',
  subscriptionCalculatingProration: 'Calculando prorrateo...',
  subscriptionProcessing: 'Procesando...',
  subscriptionConfirmUpgrade: 'Confirmar actualización',
  subscriptionConfirmDowngrade: 'Confirmar degradación',
  subscriptionConfirmChange: 'Confirmar cambio',
  subscriptionCancelSubscription: 'Cancelar suscripción',
  subscriptionHowToCancel: '¿Cómo te gustaría cancelar tu suscripción?',
  subscriptionCancelAtPeriodEnd: 'Al final del período',
  subscriptionCancelAtPeriodEndDescription: 'Tu acceso a todas las funciones premium continuará hasta el final del período actual. Esta es la opción recomendada.',
  subscriptionCancelImmediately: 'Inmediatamente',
  subscriptionCancelImmediatelyDescription: 'El acceso a las funciones premium se deshabilitará inmediatamente. No se emitirán reembolsos.',
  subscriptionKeepSubscription: 'Mantener suscripción',
  subscriptionConfirmCancellation: 'Confirmar cancelación',
  subscriptionUpgradePlan: 'Actualizar plan',
  subscriptionDowngradePlan: 'Degradar plan',
  subscriptionChangePlan: 'Cambiar plan',
  subscriptionSubscribe: 'Suscribirse',
  subscriptionPopular: 'Popular',
  subscriptionYourPlan: 'Tu plan',
  subscriptionStatusActive: 'Activo',
  subscriptionStatusTrialing: 'En prueba',
  subscriptionStatusIncomplete: 'Incompleto',
  subscriptionStatusIncompleteexpired: 'Incompleto caducado',
  subscriptionStatusPastDue: 'Pago vencido',
  subscriptionStatusCancelling: 'Cancelando',
  subscriptionStatusCancelled: 'Cancelado',
  subscriptionStatusCanceled: 'Cancelado',
  subscriptionStatusUnpaid: 'Sin pagar',
  subscriptionStatusNone: 'Sin suscripción',
  subscriptionIncompleteNotice: 'Pago incompleto. Completa tu pago para activar la suscripción.',
  subscriptionPastDueNotice: 'El pago está vencido. Actualiza tu método de pago para continuar el servicio.',

  // CRM
  contacts: 'Contactos',
  deals: 'Oportunidades',
  pipeline: 'Pipeline',
  newContact: 'Nuevo contacto',
  newDeal: 'Nueva oportunidad',
  dragToMove: 'Arrastra las oportunidades entre etapas para actualizar su estado',
  prospecting: 'Prospección',
  qualification: 'Calificación',
  proposal: 'Propuesta',
  negotiation: 'Negociación',
  won: 'Ganado',
  lost: 'Perdido',
  probability: 'Probabilidad',
  activities: 'Actividades',
  tasks: 'Tareas',
  leadScoring: 'Puntuación de leads',
  campaigns: 'Campañas',
  territories: 'Territorios',
  teams: 'Equipos',
  forecast: 'Pronóstico',

  // ERP
  expenses: 'Gastos',
  invoices: 'Facturas',
  payroll: 'Nómina',
  budgets: 'Presupuestos',
  laborCost: 'Costo laboral',
  profitLoss: 'Ganancias y pérdidas',
  inventory: 'Inventario',
  suppliers: 'Proveedores',
  purchaseOrders: 'Órdenes de compra',
  costCenters: 'Centros de costo',
  projections: 'Proyecciones',

  // Reports
  productivity: 'Productividad',
  trends: 'Tendencias',
  generateReport: 'Generar reporte',
  downloadCSV: 'Descargar CSV',
  period: 'Período',
  daily: 'Diario',
  weekly: 'Semanal',
  monthly: 'Mensual',
  quarterly: 'Trimestral',
  yearly: 'Anual',

  // Common
  save: 'Guardar',
  cancel: 'Cancelar',
  delete: 'Eliminar',
  edit: 'Editar',
  view: 'Ver',
  search: 'Buscar',
  filter: 'Filtrar',
  loading: 'Cargando...',
  error: 'Error',
  success: 'Éxito',
  noData: 'No hay datos disponibles',
  confirm: 'Confirmar',
  actions: 'Acciones',
  add: 'Agregar',
  remove: 'Quitar',
  update: 'Actualizar',
  create: 'Crear',
  export: 'Exportar',
  import: 'Importar',
  download: 'Descargar',
  upload: 'Subir',
  selectLanguage: 'Seleccionar idioma',
  liveUpdates: 'En vivo',
  disconnected: 'Desconectado',
  realtimeActivity: 'Actividad en tiempo real',
  all: 'Todos',
  today: 'Hoy',
  thisWeek: 'Esta semana',
  thisMonth: 'Este mes',
  custom: 'Personalizado',
  from: 'Desde',
  to: 'Hasta',
  apply: 'Aplicar',
  reset: 'Restablecer',
  close: 'Cerrar',
  back: 'Atrás',
  next: 'Siguiente',
  previous: 'Anterior',
  yes: 'Sí',
  no: 'No',
  or: 'o',
  and: 'y',
  total: 'Total',
  average: 'Promedio',
  min: 'Mín',
  max: 'Máx',

  // Mobile specific
  profile: 'Perfil',
  changePassword: 'Cambiar contraseña',
  notificationSettings: 'Configuración de notificaciones',
  pushNotifications: 'Notificaciones push',
  emailNotifications: 'Notificaciones por correo',
  shiftReminders: 'Recordatorios de turnos',
  availability: 'Disponibilidad',
  helpSupport: 'Ayuda y soporte',
  termsPrivacy: 'Términos y privacidad',
  version: 'Versión',
  memberSince: 'Miembro desde',
  totalShifts: 'Total de turnos',
  hoursWorked: 'Horas trabajadas',
  attendanceRate: 'Tasa de asistencia',

  // Admin Panel
  superAdminPanel: 'Panel de super administrador',
  systemWideManagement: 'Gestión y configuración a nivel de sistema',
  overview: 'Resumen',
  organizations: 'Organizaciones',
  aiSettings: 'Configuración de IA',
  allOrganizations: 'Todas las organizaciones',
  totalUsers: 'Total de usuarios',
  monthlyRecurringRevenue: 'MRR',
  organizationDetails: 'Detalles de la organización',
  subscriptionPlan: 'Plan de suscripción',
  organizationInformation: 'Información de la organización',
  created: 'Creado',
  supportEmail: 'Correo de soporte',
  supportPhone: 'Teléfono de soporte',
  monthlyCost: 'Costo mensual',
  billingPeriod: 'Período de facturación',
  domainConfiguration: 'Configuración de dominio',
  domainType: 'Tipo de dominio',
  customDomain: 'Dominio personalizado',
  fullUrl: 'URL completa',
  brandColors: 'Colores de marca',
  primary: 'Principal',
  secondary: 'Secundario',
  aiConfiguration: 'Configuración de IA',
  aiProvider: 'Proveedor de IA',
  aiModel: 'Modelo de IA',
  currentConfiguration: 'Configuración actual',
  configureAiModel: 'Configurar el modelo de IA usado para la asignación automática',
  thisModelWillBeUsed:
    'Este modelo se usará para la asignación automática con IA en todas las organizaciones Pro y Enterprise.',
  plan: 'Plan',

  // Shifts Page (extra)
  balanced: 'Equilibrado',
  costOptimized: 'Optimizado por costo',
  coverageOptimized: 'Optimizado por cobertura',
  noOpenShiftsToAssign: 'No hay turnos abiertos para asignar',
  aiAssignmentFailed: 'Falló la asignación con IA',
  failedToCreateShift: 'No se pudo crear el turno',
  failedToAssignEmployee: 'No se pudo asignar al empleado',

  // Time Tracking Page
  trackYourWorkHours: 'Registra tus horas de trabajo',
  currentlyWorking: 'Trabajando actualmente',
  startedAt: 'Comenzó a las',
  locationTracked: 'Ubicación registrada',
  readyToStart: '¿Listo para comenzar?',
  selectShiftToClockIn: 'Selecciona un turno para fichar',
  noShiftsScheduledToday: 'No hay turnos programados para hoy',
  recentTimeEntries: 'Entradas de tiempo recientes',
  noTimeEntriesYet: 'Aún no hay entradas de tiempo',
  hrs: 'h',
  failedToClockIn: 'No se pudo fichar la entrada',
  failedToClockOut: 'No se pudo fichar la salida',

  // Multi-location Page
  multiLocationTitle: 'Multi-ubicación',
  multiLocationSubtitle: 'Gestiona tus centros de trabajo y ubicaciones',
  addLocation: 'Nueva ubicación',
  filterByLocation: 'Filtrar por ubicación',
  noAssignedLocations: 'No estás asignado a ninguna ubicación',
  showingShiftsFrom: 'Mostrando turnos de:',
  allLocations: 'Todas las ubicaciones',
  locationsCountSuffix: 'ubicación(es)',
  orgAllLocations: 'Todas las ubicaciones de la organización',
  availableLocations: 'Ubicaciones disponibles',
  noLocationsConfigured: 'No hay ubicaciones configuradas',
  createFirstLocation: 'Crear la primera ubicación',
  assignedBadge: 'Asignado',
  assignedEmployeesCountLabel: 'empleados asignados',
  unassignMe: 'Desasignarme',
  assignMe: 'Asignarme',
  editLocationTitle: 'Editar ubicación',
  newLocationTitle: 'Nueva ubicación',
  locationCodeLabel: 'Código (p. ej.: A-253, HL-851)',
  locationCodePlaceholder: 'A-253',
  locationNameLabel: 'Nombre',
  locationNamePlaceholder: 'Ambulance 253',
  locationTypeLabel: 'Tipo',
  locationAddressOptionalLabel: 'Dirección (opcional)',
  locationAddressPlaceholder: 'Main Street 123',
  locationType_general: 'General',
  locationType_ambulance: 'Ambulancia',
  locationType_helicopter: 'Helicóptero',
  locationType_hospital: 'Hospital',
  locationType_office: 'Oficina',
  locationType_warehouse: 'Almacén',
  locationType_store: 'Tienda',
  locationCreated: 'Ubicación creada con éxito',
  locationCreateError: 'Error al crear la ubicación',
  locationUpdated: 'Ubicación actualizada',
  locationUpdateError: 'Error al actualizar la ubicación',
  locationDeleted: 'Ubicación eliminada',
  locationDeleteError: 'Error al eliminar la ubicación',
  locationDeleteConfirm: '¿Eliminar esta ubicación?',
  assignedToLocation: 'Asignado a la ubicación',
  unassignedFromLocation: 'Desasignado de la ubicación',

  // Shift Swap Page
  shiftSwapTitle: 'Intercambio de turnos',
  shiftSwapSubtitle: 'Solicita intercambios y publica tu disponibilidad',
  postAvailability: 'Publicar disponibilidad',
  requestSwap: 'Solicitar intercambio',
  urgentCoveragesTitle: 'Coberturas urgentes',
  noLocation: 'Sin ubicación',
  takeShift: 'Tomar turno',
  swapRequestsTab: 'Solicitudes de intercambio',
  myAvailabilityTab: 'Mi disponibilidad',
  noActiveSwapRequests: 'No hay solicitudes de intercambio activas',
  createFirstSwapRequest: 'Crear la primera solicitud',
  requestedBy: 'Solicitado por',
  userFallback: 'Usuario',
  statusPending: 'Pendiente',
  statusAccepted: 'Aceptado',
  statusRejected: 'Rechazado',
  statusActive: 'Activo',
  available: 'Disponible',
  preferenceLabel: 'Preferencia',
  preferenceMorning: 'Mañana',
  preferenceAfternoon: 'Tarde',
  preferenceNight: 'Noche',
  preferenceAny: 'Cualquiera',
  timePreference: 'Preferencia de horario',
  preferenceAnyWithRange: 'Cualquier horario',
  preferenceMorningWithRange: 'Mañana (6:00 - 14:00)',
  preferenceAfternoonWithRange: 'Tarde (14:00 - 22:00)',
  preferenceNightWithRange: 'Noche (22:00 - 6:00)',
  noAvailabilityPublished: 'No has publicado disponibilidad',
  publishAvailabilityHint: 'Publica cuándo estás disponible para recibir ofertas de intercambio',
  swapReasonDefault: 'Solicitud de intercambio de turno',
  swapRequestCreated: 'Solicitud de intercambio creada',
  swapRequestCreateError: 'Error al crear la solicitud de intercambio',
  availabilityPosted: 'Disponibilidad publicada',
  swapAccepted: 'Intercambio aceptado',
  urgentShiftTaken: '¡Turno asignado con éxito!',
  urgentShiftError: 'Error al tomar el turno',
  swapRequestCancelled: 'Solicitud de intercambio cancelada',
  selectShiftForSwap: 'Selecciona uno de tus próximos turnos para solicitar un intercambio:',
  swapInfoPlaceholder: 'Los turnos disponibles para intercambio aparecerán aquí.',
  swapInfoHint: 'Ve a tu calendario de turnos para seleccionar uno.',

  // Chat Page
  channels: 'Canales',
  searchPlaceholder: 'Buscar...',
  noChannels: 'No hay canales',
  createFirstChannel: 'Crea el primero',
  membersLabel: 'miembros',
  noMessagesYet: 'Aún no hay mensajes',
  beFirstToWrite: '¡Sé el primero en escribir!',
  messagePlaceholder: 'Mensaje en #{channel}',
  selectChannelPrompt: 'Selecciona un canal',
  selectChannelHint: 'o crea uno nuevo para comenzar',
  editedLabel: '(editado)',
  messageDeleted: 'Mensaje eliminado',
  createChannelTitle: 'Crear canal',
  channelNameLabel: 'Nombre del canal *',
  channelNamePlaceholder: 'general',
  channelDescriptionLabel: 'Descripción',
  channelDescriptionPlaceholder: '¿De qué trata este canal?',
  channelTypeLabel: 'Tipo de canal',
  channelTypePublic: 'Público',
  channelTypePrivate: 'Privado',
  createChannelAction: 'Crear canal',

  // Layout / Navigation sections & mobile nav
  mainSection: 'Principal',
  toolsSection: 'Herramientas',
  adminSection: 'Administración',
  markAllRead: 'Marcar todo como leído',
  noNotifications: 'No hay notificaciones',
  mobileHome: 'Inicio',
  mobileShifts: 'Turnos',
  mobileClock: 'Reloj',
  mobileTeam: 'Equipo',
  mobileMore: 'Más',

  // Chat Page (super admin org selector)
  allOrganizationsOption: 'Todas las organizaciones',
  selectOrgForChat: 'Selecciona una organización para ver sus canales de chat.',
  selectOrgForChatTitle: 'Selecciona una organización',
  selectOrgForChatDescription:
    'Como super administrador, elige una organización desde la barra lateral para ver y gestionar sus canales internos de chat.',

  // Leave Page
  leaveTitle: 'Permisos y ausencias',
  leaveSubtitle: 'Gestiona tus vacaciones y solicitudes de tiempo libre',
  leaveNewRequest: 'Nueva solicitud',
  leaveMyBalanceTab: 'Mi saldo',
  leaveMyRequestsTab: 'Mis solicitudes',
  leaveYearLabel: 'Año',
  leaveTotalAnnual: 'Total anual',
  leaveUsed: 'Usado',
  leavePending: 'Pendiente',
  leaveAvailable: 'Disponible',
  leaveDaysSuffix: 'días',
  leaveNoPolicies: 'No hay políticas de permisos configuradas',
  leaveNoRequestsTitle: 'Sin solicitudes',
  leaveNoRequestsSubtitle: 'No tienes solicitudes de vacaciones o permisos',
  leaveCreateFirstRequest: 'Crear la primera solicitud',
  leaveRejectionReasonLabel: 'Motivo',
  leaveRequestCreated: 'Solicitud creada correctamente',
  leaveSelectDatesError: 'Por favor selecciona fecha de inicio y fin',
  leaveTypeLabel: 'Tipo de permiso',
  leaveAvailableDaysLabel: 'Días disponibles:',
  leaveStartDate: 'Fecha de inicio',
  leaveEndDate: 'Fecha de fin',
  leaveHalfDay: 'Medio día',
  leaveReasonOptional: 'Motivo (opcional)',
  leaveReasonPlaceholder: 'Describe el motivo de tu solicitud...',
  leaveSubmitRequest: 'Enviar solicitud',
  leaveTeamRequestsTab: 'Solicitudes del Equipo',
  leaveTeamNoRequestsTitle: 'Sin solicitudes del equipo',
  leaveTeamNoRequestsSubtitle: 'No hay solicitudes de vacaciones o permisos pendientes para tu equipo.',
  leaveApprove: 'Aprobar',
  leaveReject: 'Rechazar',
  leaveRequestApproved: 'Solicitud aprobada',
  leaveRequestRejected: 'Solicitud rechazada',
  leaveApproveError: 'Error al aprobar la solicitud',
  leaveRejectError: 'Error al rechazar la solicitud',
  leaveRejectPrompt: 'Motivo de rechazo (opcional)',
  leaveCurrentApproverLabel: 'Actualmente con:',
  roleManager: 'Manager',
  roleOrgAdmin: 'Administrador de organización',
  roleSuperAdmin: 'Super administrador',

  // Gamification Page
  gamificationTabProfile: 'Mi Perfil',
  gamificationTabChallenges: 'Desafíos',
  gamificationTabBadges: 'Insignias',
  gamificationTabLeaderboard: 'Clasificación',
  gamificationTabRewards: 'Recompensas',
  gamificationOptInTitle: '¡Únete al Programa de Recompensas!',
  gamificationOptInSubtitle:
    'Gana puntos por puntualidad, ayudar a tus compañeros y canjéalos por recompensas increíbles.',
  gamificationOptInComplianceTitle: 'Cumplimiento GDPR/HIPAA',
  gamificationOptInPoint1: 'Solo se registran datos de rendimiento laboral',
  gamificationOptInPoint2: 'Puedes darte de baja y eliminar tus datos en cualquier momento',
  gamificationOptInPoint3: 'La participación en la clasificación es opcional',
  gamificationOptInJoining: 'Uniéndote...',
  gamificationOptInCTA: 'Unirme ahora',
  gamificationHeaderTitle: 'Programa de Recompensas',
  gamificationLevelLabel: 'Nivel {{level}}',
  gamificationCurrentStreakLabel: 'racha de {{days}} días',
  gamificationTotalPointsLabel: 'Puntos totales',
  gamificationCurrentPeriodLabel: 'Este período',
  gamificationCurrentStreakTitle: 'Racha actual',
  gamificationConsecutiveDaysLabel: 'días consecutivos',
  gamificationBestStreakLabel: 'Mejor: {{days}} días',
  gamificationOnTimeLabel: 'Llegadas puntuales',
  gamificationThisPeriodLabel: 'este período',
  gamificationBadgesOfTotalLabel: 'de {{total}} en total',
  gamificationChallengesTitle: 'Desafíos de esta semana',
  gamificationChallengesCompletedLabel: '{{completed}}/{{total}} completados',
  gamificationClaimRewardButton: 'Reclamar recompensa',
  gamificationRewardAlreadyClaimed: 'Recompensa reclamada',
  gamificationNoChallengesMessage: 'No hay desafíos activos esta semana',
  gamificationEarnedBadgesTitle: 'Insignias ganadas',
  gamificationAvailableBadgesTitle: 'Disponibles',
  gamificationAnonymousLabel: 'Anónimo',
  gamificationOnTimeCountLabel: '{{count}} llegadas puntuales',
  gamificationPointsSuffix: 'puntos',
  gamificationNoLeaderboardMessage: 'Aún no hay participantes. ¡Sé el primero!',
  gamificationRewardCostLabel: '{{points}} pts',
  gamificationRedeemButton: 'Canjear',
  gamificationNoRewardsMessage: 'No hay recompensas disponibles. Pregunta a tu administrador.',
  gamificationRewardRedeemed: '¡Recompensa canjeada!',
  gamificationRewardRedeemError: 'Error al canjear la recompensa',

  // Hours & Documents Page
  hoursDocumentsTitle: 'Horas y documentos',
  hoursDocumentsSubtitle: 'Seguimiento de horas trabajadas y gestión de documentos',
  exportPDF: 'Exportar PDF',
  pdfDownloadedSuccessfully: 'PDF descargado correctamente',
  documentReadyToPrint: 'Documento listo para imprimir',
  exportError: 'Error de exportación',
  selectFile: 'Por favor, selecciona un archivo',
  documentUploadedSuccessfully: 'Documento subido correctamente',
  documentUploadError: 'Error al subir el documento',
  deleteDocumentConfirm: '¿Eliminar este documento?',
  documentDeleted: 'Documento eliminado',
  documentDeleteError: 'Error al eliminar el documento',
  hoursSummaryTab: 'Resumen de horas',
  totalHoursLabel: 'Total de horas',
  teamAverage: 'Promedio del equipo',
  regularHours: 'Horas regulares',
  overtimeHours: 'Horas extra',
  multiplier: 'Multiplicador',
  nightHours: 'Horas nocturnas',
  detailedBreakdown: 'Desglose detallado',
  saturdays: 'Sábados',
  sundays: 'Domingos',
  holidays: 'Festivos',
  totalEquivalent: 'Total equivalente',
  shiftsCompleted: 'Turnos completados',
  daysWorked: 'Días trabajados',
  dailyAverage: 'Promedio diario',
  uploadDocument: 'Subir documento',
  documentType: 'Tipo de documento',
  descriptionOptional: 'Descripción (opcional)',
  documentDescriptionPlaceholder: 'Ej.: Baja médica enero 2026',
  file: 'Archivo',
  myDocuments: 'Mis documentos',
  noDocumentsUploaded: 'No has subido ningún documento',
  uploaded: 'Subido',
  approved: 'Aprobado',
  rejected: 'Rechazado',
  documentTypeSickLeave: 'Baja médica',
  documentTypeCertification: 'Certificación',
  documentTypeTraining: 'Formación',
  documentTypeContract: 'Contrato',
  documentTypeOther: 'Otro',
  monthJanuary: 'Enero',
  monthFebruary: 'Febrero',
  monthMarch: 'Marzo',
  monthApril: 'Abril',
  monthMay: 'Mayo',
  monthJune: 'Junio',
  monthJuly: 'Julio',
  monthAugust: 'Agosto',
  monthSeptember: 'Septiembre',
  monthOctober: 'Octubre',
  monthNovember: 'Noviembre',
  monthDecember: 'Diciembre',

  // Digital Signatures Page
  digitalSignaturesTitle: 'Firmas digitales',
  digitalSignaturesSubtitle: 'Gestión de documentos y firma electrónica con validez legal',
  newDocument: 'Nuevo documento',
  youHavePendingDocuments: 'Tienes {count} documento(s) pendientes de firma',
  clickPendingToSign: 'Haz clic en "Pendientes" para ver y firmar documentos',
  documentsTab: 'Documentos',
  pendingTab: 'Pendientes',
  myCertificates: 'Mis certificados',
  standardsTab: 'Estándares',
  partiallySigned: 'Firmados parcialmente',
  expired: 'Caducados',
  draft: 'Borrador',
  noDocuments: 'Sin documentos',
  createNewDocumentToSend: 'Crea un nuevo documento para enviarlo a firma',
  noDocumentsAssigned: 'No tienes documentos asignados',
  expires: 'Caduca',
  signNow: 'Firmar ahora',
  allSigned: '¡Todo firmado!',
  noPendingDocuments: 'No tienes documentos pendientes de firma',
  myDigitalCertificates: 'Mis certificados digitales',
  addCertificate: 'Añadir certificado',
  noCertificates: 'Sin certificados',
  addDigitalCertificate: 'Añade un certificado digital para firmas avanzadas y cualificadas',
  supportedCertificates: 'Certificados compatibles:',
  x509Pkcs12: 'X.509 / PKCS#12',
  electronicIdSpain: 'DNI electrónico (España)',
  qualifiedEidas: 'Certificados eIDAS cualificados',
  nationalCa: 'Certificados de CA nacionales',
  qualified: 'Cualificado',
  validUntil: 'Válido hasta',
  certificateRegistered: 'Certificado registrado correctamente',
  rostafySupportsSignatures: 'Rostafy admite firmas electrónicas con validez legal en múltiples jurisdicciones',
  availableSignatureTypes: 'Tipos de firma disponibles:',
  requiresCertificate: 'Requiere certificado',
  qualifiedCertificate: 'Certificado cualificado',
  maximum: 'Máxima',
  high: 'Alta',
  valid: 'Válida',
  createDocumentForSignature: 'Crear documento para firma',
  title: 'Título',
  documentTitlePlaceholder: 'Ej.: Contrato de trabajo - John Doe',
  documentContent: 'Contenido del documento',
  documentContentPlaceholder: 'Pega aquí el contenido HTML o el texto del documento...',
  legalRegion: 'Región legal',
  signatureType: 'Tipo de firma',
  simplePinEmail: 'Simple (PIN/Email)',
  advancedCertificate: 'Avanzada (Certificado)',
  qualifiedQualified: 'Cualificada (Certificado cualificado)',
  signers: 'Firmantes',
  addSigner: 'Añadir firmante',
  name: 'Nombre',
  signer: 'Firmante',
  approver: 'Aprobador',
  witness: 'Testigo',
  daysToSign: 'Días para firmar',
  createDocument: 'Crear documento',
  documentCreated: 'Documento creado correctamente',
  errorCreatingDocument: 'Error al crear el documento',
  signDocument: 'Firmar documento',
  simple: 'Simple',
  pinVerification: 'Verificación por PIN',
  advanced: 'Avanzada',
  withDigitalCertificate: 'Con certificado digital',
  qualifiedQes: 'Cualificada (QES)',
  maximumLegalValidity: 'Máxima validez legal',
  selectCertificate: 'Selecciona un certificado...',
  certificate: 'Certificado',
  signatureMethod: 'Método de firma',
  typeName: 'Escribe tu nombre',
  clickToSign: 'Haz clic para firmar',
  yourFullName: 'Tu nombre completo',
  typeYourFullName: 'Escribe tu nombre completo',
  confirmationPin: 'PIN de confirmación',
  enterPinDigits: 'Introduce un PIN de 4 a 6 dígitos',
  legalNotice: 'Al firmar, confirmo que he leído y acepto el contenido del documento. Esta firma tiene validez legal según la normativa aplicable.',
  signDocumentButton: 'Firmar documento',
  documentSigned: 'Documento firmado correctamente',
  errorSigning: 'Error al firmar',
  registerCertificate: 'Registrar certificado',
  type: 'Tipo',
  issuer: 'Emisor',
  issuerPlaceholder: 'Ej.: FNMT, DigiCert, etc.',
  serialNumber: 'Número de serie',
  serialNumberPlaceholder: 'Número de serie del certificado',
  validFrom: 'Válido desde',
  validUntilLabel: 'Válido hasta',
  certificateDataBase64: 'Datos del certificado (Base64)',
  certificateDataPlaceholder: 'Pega aquí el certificado en formato Base64...',
  errorRegisteringCertificate: 'Error al registrar el certificado',
  send: 'Enviar',
  documentSent: 'Documento enviado para firma',
  errorSending: 'Error al enviar',
  signed: 'firmado',
  region: 'Región',

  // Reports Page
  reportsSubtitle: 'Genera y exporta informes',
  reportsPeriodTitle: 'Periodo del informe',
  reportsShiftsDescription: 'Lista de turnos con asignaciones',
  reportsHoursDescription: 'Desglose de horas por empleado',
  reportsAttendanceDescription: 'Tasa de asistencia por empleado',
  reportsSwapsDescription: 'Solicitudes de cambio de turno',
  reportsComplianceDescription: 'Infracciones de reglas y políticas',
  reportsPayrollDescription: 'Resumen de pagos calculados',
  reportsProductivityDescription: 'Métricas de rendimiento por empleado',
  reportsLaborCostDescription: 'Análisis diario y semanal de costes laborales',
  reportsTrendsDescription: 'Análisis histórico de los últimos meses',
  reportsHourlyRateLabel: '€/hora',
  reportsOvertimeMultiplierLabel: 'Horas extra x',
  reportsTrendsMonthsLabel: 'Meses a analizar',
  reportsLast3Months: 'Últimos 3 meses',
  reportsLast6Months: 'Últimos 6 meses',
  reportsLast12Months: 'Último año',
  reportsLast24Months: 'Últimos 2 años',
  reportsDownloaded: 'Informe descargado',
  reportsGenerateError: 'Error al generar el informe',
  reportsReportLabel: 'Informe',
  reportsGeneratedAt: 'Generado',
  reportsDownloadJsonButton: 'Descargar JSON',
  reportsLimitedRows: 'Mostrando 20 de {total} registros. Descarga el JSON para verlos todos.',

  // Payroll Page
  payrollTitle: 'Gestión de nóminas',
  payrollSubtitle: 'Calcula y gestiona la nómina de tus empleados',
  payrollExportSuccess: 'Exportación completada',
  payrollExportError: 'Error al exportar',
  payrollPeriodApproved: 'Periodo aprobado',
  payrollApproveError: 'Error al aprobar el periodo',
  payrollCurrencyLabel: 'Moneda',
  payrollPayPeriodLabel: 'Periodo de pago',
  payrollOvertimeMultiplierSummary: 'Mult. extra',
  payrollNightMultiplierSummary: 'Mult. noche',
  payrollPeriodsTitle: 'Periodos de nómina',
  payrollNoPeriodsTitle: 'Sin periodos',
  payrollNoPeriodsSubtitle: 'Crea tu primer periodo de nómina para empezar',
  payrollCreateFirstPeriod: 'Crear periodo',
  payrollTotalGross: 'Total bruto',
  payrollTotalNet: 'Total neto',
  payrollViewDetails: 'Ver detalles',
  payrollApprove: 'Aprobar',
  payrollExportCsv: 'Exportar CSV',
  payrollEmployeesLabel: 'empleados',
  payrollNoEntriesTitle: 'Sin entradas calculadas',
  payrollNoEntriesSubtitle: 'Ejecuta el cálculo de nómina para ver los detalles',
  payrollHoursRegular: 'Ordinarias',
  payrollHoursOvertime: 'Extras',
  payrollHoursNight: 'Nocturnas',
  payrollHoursWeekend: 'Fin de semana',
  payrollHoursHoliday: 'Festivo',
  payrollGrossLabel: 'Bruto',
  payrollIncomeTaxLabel: 'Impuesto sobre la renta',
  payrollSocialSecurityLabel: 'Seguridad social',
  payrollSelectDatesError: 'Selecciona las fechas',
  payrollCreatePeriodError: 'Error al crear el periodo',
  payrollNewPeriod: 'Nuevo periodo de nómina',
  payrollPeriodNameOptional: 'Nombre (opcional)',
  payrollPeriodNamePlaceholder: 'Nómina de enero de 2026',
  payrollStartDateLabel: 'Fecha de inicio *',
  payrollEndDateLabel: 'Fecha de fin *',
  payrollCreatePeriod: 'Crear periodo',
  payrollSettingsTitle: 'Ajustes de nómina',
  payrollOvertimeMultiplierLabel: 'Horas extra',
  payrollNightMultiplierLabel: 'Noche',
  payrollWeekendMultiplierLabel: 'Fin de semana',
  payrollHolidayMultiplierLabel: 'Festivo',
  payrollDefaultDeductionsTitle: 'Deducciones por defecto',

  // AI Auto-Assign Page
  aiAutoAssignTitle: 'Asignación automática con IA',
  aiAutoAssignSubtitle: 'Genera horarios automáticamente respetando las reglas de tu organización',
  aiAutoAssignTabGenerate: 'Generar horario',
  aiAutoAssignTabRules: 'Reglas de la organización',
  aiAutoAssignTabTemplates: 'Plantillas de turnos',
  aiAutoAssignTabHistory: 'Historial',
  aiAutoAssignStatRunsLast30Days: 'Ejecuciones (30d)',
  aiAutoAssignStatAssignments: 'Asignaciones',
  aiAutoAssignSelectPeriod: 'Seleccionar periodo',
  aiAutoAssignModePreview: 'Vista previa',
  aiAutoAssignModePreviewDesc: 'Ver sin guardar',
  aiAutoAssignModeDraft: 'Borrador',
  aiAutoAssignModeDraftDesc: 'Guardar como borrador',
  aiAutoAssignModeApply: 'Aplicar',
  aiAutoAssignModeApplyDesc: 'Guardar y activar',
  aiAutoAssignGenerating: 'Generando...',
  aiAutoAssignGenerateButton: 'Generar horario',
  aiAutoAssignResultTitleSuccess: 'Horario generado',
  aiAutoAssignModeAppliedBadge: 'Aplicado',
  aiAutoAssignModeDraftBadge: 'Borrador',
  aiAutoAssignModePreviewBadge: 'Vista previa',
  aiAutoAssignPeriodLabel: 'Periodo',
  aiAutoAssignSummaryShiftsGenerated: 'Turnos generados',
  aiAutoAssignSummaryAssignments: 'Asignaciones',
  aiAutoAssignSummaryUnassigned: 'Sin asignar',
  aiAutoAssignSummaryWarnings: 'Avisos',
  aiAutoAssignAssignmentsTitle: 'Asignaciones',
  aiAutoAssignScoreLabel: 'Puntuación',
  aiAutoAssignWarningsTitle: 'Avisos',
  aiAutoAssignUnassignedTitle: 'Puestos sin asignar',
  aiAutoAssignMissingLabel: 'faltan',
  aiAutoAssignRulesTitle: 'Tus reglas de la organización',
  aiAutoAssignEditRulesButton: 'Editar reglas',
  aiAutoAssignRulesInfo: 'Estas reglas se aplican automáticamente al generar horarios. Personalízalas según tus acuerdos y políticas internas.',
  aiAutoAssignOptionsTitle: 'Opciones',
  aiAutoAssignActiveLabel: 'Activo',
  aiAutoAssignInactiveLabel: 'Inactivo',
  aiAutoAssignTemplatesTitle: 'Plantillas de turnos',
  aiAutoAssignNewTemplate: 'Nueva plantilla',
  aiAutoAssignPositionsLabel: 'puestos',
  aiAutoAssignHistoryTitle: 'Historial de ejecuciones',
  aiAutoAssignNoRuns: 'Aún no hay ejecuciones registradas',
  aiAutoAssignHistoryShifts: 'turnos',
  aiAutoAssignHistoryAssigned: 'asignados',
  aiAutoAssignHistoryUnassigned: 'sin asignar',
  aiAutoAssignRuleMaxHoursWeek: 'Máx. horas/semana',
  aiAutoAssignRuleMaxHoursDay: 'Máx. horas/día',
  aiAutoAssignRuleMinRestBetweenShifts: 'Descanso mínimo entre turnos',
  aiAutoAssignRuleMaxConsecutiveDays: 'Máx. días consecutivos',
  aiAutoAssignRuleMaxConsecutiveWeekends: 'Máx. fines de semana consecutivos',
  aiAutoAssignRuleMaxConsecutiveNights: 'Máx. noches consecutivas',
  aiAutoAssignRuleOvertimeThreshold: 'Umbral de horas extra',
  aiAutoAssignRuleRestAfterNightHours: 'Descanso tras turno nocturno',
  aiAutoAssignBoolOvertimeRequiresApproval: 'Las horas extra requieren aprobación',
  aiAutoAssignBoolRespectPreferences: 'Respetar preferencias del empleado',
  aiAutoAssignBoolBalanceWorkload: 'Equilibrar la carga de trabajo',
  aiAutoAssignBoolRotationWeekends: 'Rotar fines de semana',
  aiAutoAssignBoolNightShiftLimits: 'Aplicar límites de turnos nocturnos',
  aiAutoAssignSaveRulesError: 'Error al guardar las reglas',
  aiAutoAssignGenerateError: 'Error al generar el horario'

  // AI Predictions Page
  ,aiPredictionsTitle: 'Predicciones con IA',
  aiPredictionsSubtitle: 'Análisis inteligente con Aria para optimizar la plantilla',
  aiPredictionsRefreshButton: 'Actualizar',
  aiPredictionsGdprTitle: 'Cumplimiento GDPR/HIPAA:',
  aiPredictionsGdprText:
    'Todas las predicciones usan datos agregados y anonimizados. No se recopila ni almacena información sanitaria personal.',
  aiPredictionsTabDemand: 'Previsión de demanda',
  aiPredictionsTabBurnout: 'Detección de burnout',
  aiPredictionsTabChurn: 'Predicción de rotación',
  aiPredictionsTabCosts: 'Optimización de costes',
  aiPredictionsTabComprehensive: 'Análisis Aria',
  aiPredictionsAriaAnalysisLabel: 'Análisis de Aria',
  aiPredictionsEmployeesLabel: 'empleados',
  aiPredictionsWeekendBadge: 'Fin de semana',
  aiPredictionsHourlyBreakdownTitle: 'Desglose por hora (hoy)',
  aiPredictionsForecastInsightTitle: 'Análisis de IA de la previsión',
  aiPredictionsBurnoutTeamHealth: 'Salud del equipo',
  aiPredictionsBurnoutRiskDistribution: 'Distribución del riesgo',
  aiPredictionsRiskLow: 'Bajo',
  aiPredictionsRiskModerate: 'Moderado',
  aiPredictionsRiskHigh: 'Alto',
  aiPredictionsRiskCritical: 'Crítico',
  aiPredictionsPrivacyNoticeTitle: 'Aviso de privacidad:',
  aiPredictionsChurnRetentionHealth: 'Salud de retención',
  aiPredictionsChurnExitRisk: 'Riesgo de salida',
  aiPredictionsChurnAtRiskLabel: '{{percent}}% del equipo',
  aiPredictionsChurnTeamAnalyzed: 'Equipo analizado',
  aiPredictionsChurnOfTeamLabel: 'de {{count}} empleados',
  aiPredictionsChurnRiskDistribution: 'Distribución del riesgo de rotación',
  aiPredictionsChurnNoticeTitle: 'Predicción de IA:',
  aiPredictionsChurnNoticeText:
    'La predicción de rotación se basa en patrones de trabajo (horas, puntualidad, cancelaciones) – no en datos personales. Los empleados con alto riesgo pueden beneficiarse de conversaciones proactivas sobre desarrollo profesional.',
  aiPredictionsCostsTotalLabor: 'Coste laboral total',
  aiPredictionsLastNDays: 'últimos {{days}} días',
  aiPredictionsCostsOvertime: 'Horas extra',
  aiPredictionsCostsOvertimeCost: 'coste de ${{value}}',
  aiPredictionsCostsSavingsPotential: 'Potencial de ahorro',
  aiPredictionsCostsSavingsHint: 'ahorro posible',
  aiPredictionsCostsAvgHourly: 'Coste horario medio',
  aiPredictionsOptimizationSuggestionsTitle: 'Sugerencias de optimización',
  aiPredictionsPriorityHigh: 'ALTA PRIORIDAD',
  aiPredictionsPriorityMedium: 'PRIORIDAD MEDIA',
  aiPredictionsPriorityLow: 'BAJA PRIORIDAD',
  aiPredictionsSavingsLabel: 'Ahorra ${{value}}',
  aiPredictionsImpactLabel: 'Impacto',
  aiPredictionsCostsInsightTitle: 'Análisis de Aria – Optimización de costes',
  aiPredictionsComprehensiveLoading: 'Aria está analizando tu organización...',
  aiPredictionsComprehensiveLoadingHint: 'Esto puede tardar entre 15 y 30 segundos',
  aiPredictionsTeamSizeLabel: 'Tamaño del equipo',
  aiPredictionsTeamHealthLabel: 'Salud del equipo',
  aiPredictionsBurnoutAtRiskLabel: 'En riesgo de burnout',
  aiPredictionsSavingsPotentialLabel: 'Potencial de ahorro',
  aiPredictionsComprehensiveTitle: 'Análisis integral de Aria',
  aiPredictionsComprehensiveMeta:
    'Industria: {{industry}} | Generado: {{date}}',
  aiPredictionsBadgeGdpr: 'Cumple GDPR',
  aiPredictionsBadgeHipaa: 'Cumple HIPAA',
  aiPredictionsBadgePoweredByAria: 'Impulsado por Aria',
  aiPredictionsComprehensiveIntroTitle: 'Análisis integral con Aria',
  aiPredictionsComprehensiveIntroText:
    'Aria analizará todos los datos de tu organización para generar recomendaciones estratégicas personalizadas.',
  aiPredictionsComprehensiveButton: 'Generar análisis con Aria',

  // Settings Page
  settingsSubtitle: 'Personaliza tu organización',
  settingsTabBranding: 'Marca',
  settingsTabSmtp: 'Correo (SMTP)',
  settingsTabSms: 'SMS',
  settingsTabDomain: 'Dominio',
  settingsTabCalendar: 'Calendario',
  settingsTabSecurity: 'Seguridad',
  settingsNoOrganizationTitle: 'Sin organización',
  settingsNoOrganizationSubtitle: 'Primero debes crear o unirte a una organización.',

  // Branding subsection
  settingsBrandingTitle: 'Personalización de marca',
  settingsBrandingDescription:
    'Personaliza los colores y la información de tu organización para crear una experiencia de marca única.',
  settingsBrandingColorsTitle: 'Colores de marca',
  settingsAccentColorLabel: 'Color de acento',
  settingsBrandingPreviewTitle: 'Vista previa',
  settingsBrandingPrimaryButton: 'Botón principal',
  settingsBrandingSecondaryButton: 'Botón secundario',
  settingsBrandingAccentButton: 'Acento',
  settingsBrandingSaved: '¡Ajustes de marca guardados!',
  saveChanges: 'Guardar cambios',

  // SMTP subsection
  settingsSmtpTitle: 'Configuración de correo (SMTP)',
  settingsSmtpDescription:
    'Configura tu propio servidor SMTP para enviar correos a tus empleados desde tu dominio.',
  settingsSmtpConfigured: 'SMTP configurado y activo',
  settingsSmtpServerLabel: 'Servidor SMTP',
  settingsSmtpPortLabel: 'Puerto',
  settingsSmtpUserLabel: 'Usuario',
  settingsSmtpPasswordLabel: 'Contraseña',
  settingsSmtpFromEmailLabel: 'Correo del remitente',
  settingsSmtpFromNameLabel: 'Nombre del remitente',
  settingsSmtpUseTlsLabel: 'Usar TLS/STARTTLS',
  settingsTestConfigurationTitle: 'Probar configuración',
  settingsSendTestButton: 'Enviar prueba',
  settingsSmtpSaved: '¡Ajustes SMTP guardados!',
  settingsSaveSmtpButton: 'Guardar SMTP',
  settingsSmtpTestEmailRequired: 'Introduce un correo de prueba',
  settingsSmtpTestSuccess: '¡Correo de prueba enviado correctamente!',
  settingsSmtpTestError: 'Error al probar SMTP',
  settingsSmtpErrorSaving: 'Error al guardar la configuración SMTP',

  // Generic save error
  settingsSaveError: 'Error al guardar',

  // SMS subsection
  settingsSmsTitle: 'Configuración de SMS',
  settingsSmsDescription: 'Configura tu proveedor de SMS para enviar notificaciones a tus empleados.',
  settingsSmsSaved: '¡Ajustes de SMS guardados!',
  settingsSmsDeleted: 'Configuración de SMS eliminada',
  settingsSmsErrorSaving: 'Error al guardar la configuración de SMS',
  settingsSmsErrorDeleting: 'Error al eliminar la configuración de SMS',
  settingsSmsProviderLabel: 'Proveedor de SMS',
  settingsSmsProviderTwilio: 'Twilio',
  settingsSmsProviderTwilioDescription: 'Más popular',
  settingsSmsProviderVonage: 'Vonage (Nexmo)',
  settingsSmsProviderVonageDescription: 'Cobertura global',
  settingsSmsProviderMessagebird: 'MessageBird',
  settingsSmsProviderMessagebirdDescription: 'Europa y más',
  settingsSmsProviderCustom: 'API personalizada',
  settingsSmsProviderCustomDescription: 'Tu propio proveedor',
  settingsSmsPhoneLabel: 'Número de teléfono',
  settingsSmsTwilioHelp: 'Obtén tus credenciales en',
  settingsSmsFromLabel: 'Remitente (From)',
  settingsSmsCustomUrlLabel: 'URL de la API',
  settingsSmsCustomMethodLabel: 'Método',
  settingsSmsCustomBodyLabel: 'Plantilla del cuerpo (JSON)',
  settingsSmsCustomBodyHint: 'Usa {{phone}} y {{message}} como variables',
  settingsSmsCustomAuthLabel: 'Autenticación',
  settingsSmsAuthNone: 'Sin autenticación',
  settingsSmsAuthValueLabel: 'Valor de autenticación',
  settingsSmsTestPhoneRequired: 'Introduce un teléfono de prueba',
  settingsSmsTestSuccess: '¡SMS de prueba enviado!',
  settingsSmsTestError: 'Error al probar SMS',
  settingsSmsDeleteConfirm: '¿Eliminar la configuración de SMS?',
  settingsSaveSmsButton: 'Guardar SMS',
  settingsSmsTestConfigTitle: 'Probar configuración',

  // Domain subsection
  settingsDomainTitle: 'Configuración de dominio',
  settingsDomainDescription: 'Configura un dominio personalizado para tu plataforma de turnos.',
  settingsDomainSaved: 'Ajustes de dominio guardados!',
  settingsDomainErrorSaving: 'Error al guardar el dominio',
  settingsDomainDnsInstructionsTitle: 'Instrucciones de configuración DNS',
  settingsDomainCurrentLabel: 'Dominio actual:',
  settingsDomainTypeLabel: 'Tipo de dominio',
  settingsDomainOptionSubdomainTitle: 'Subdominio de ROSTAFY (Gratis)',
  settingsDomainOptionCustomTitle: 'Tu propio dominio (Gratis)',
  settingsDomainOptionCustomDescription: 'Usa un dominio que ya tengas',
  settingsDomainOptionManagedTitle: 'Dominio gestionado por ROSTAFY',
  settingsDomainOptionManagedBadge: '+9.99€/mes',
  settingsDomainOptionManagedDescription: 'Nosotros adquirimos y configuramos el dominio por ti',
  settingsDomainCnameLabel: 'Apunta tu CNAME a:',
  settingsDomainSaveButton: 'Guardar configuración',
  settingsDomainVerifyButton: 'Verificar DNS',
  settingsDomainVerifyError: 'Error al verificar el dominio',

  // Calendar subsection
  settingsCalendarTitle: 'Sincronización de calendario',
  settingsCalendarDescription:
    'Sincroniza tus turnos con tu calendario favorito (Google Calendar, Outlook, Apple Calendar, etc.)',
  settingsCalendarNoFeedTitle: 'No hay un feed de calendario configurado',
  settingsCalendarNoFeedSubtitle: 'Configura tu feed para sincronizar tus turnos con cualquier calendario.',
  settingsCalendarSetupButton: 'Configurar feed de calendario',
  settingsCalendarSetupSuccess: '¡Feed de calendario configurado correctamente!',
  settingsCalendarFeedConfigured: 'Feed de calendario configurado y activo',
  settingsCalendarUrlLabel: 'Tu URL de calendario',
  settingsCalendarCopySuccess: 'URL copiada al portapapeles',
  settingsCalendarHowToAddTitle: 'Cómo añadirlo a tu calendario:',
  settingsCalendarGoogleTitle: '📅 Google Calendar',
  settingsCalendarGoogleStep1: '1. Abre Google Calendar',
  settingsCalendarGoogleStep2: '2. Haz clic en + junto a Otros calendarios',
  settingsCalendarGoogleStep3: '3. Selecciona Desde URL',
  settingsCalendarGoogleStep4: '4. Pega la URL de arriba',
  settingsCalendarOutlookTitle: '📧 Microsoft Outlook',
  settingsCalendarOutlookStep1: '1. Abre el calendario de Outlook',
  settingsCalendarOutlookStep2: '2. Añadir calendario → Suscribirse',
  settingsCalendarOutlookStep3: '3. Pega la URL de arriba',
  settingsCalendarOutlookStep4: '4. Haz clic en Importar',
  settingsCalendarAppleTitle: '🍎 Apple Calendar',
  settingsCalendarAppleStep1: '1. Abre Calendario en Mac/iPhone',
  settingsCalendarAppleStep2: '2. Archivo → Nueva suscripción',
  settingsCalendarAppleStep3: '3. Pega la URL de arriba',
  settingsCalendarAppleStep4: '4. Haz clic en Suscribirse',
  settingsCalendarWebcalTitle: '🔗 URL WebCal',
  settingsCalendarWebcalOpen: 'Abrir en la app de calendario',
  settingsCalendarRegenerateTitle: 'Regenerar URL',
  settingsCalendarRegenerateDescription:
    'Si crees que tu URL se ha visto comprometida, genera una nueva.',
  settingsCalendarRegenerateButton: 'Regenerar',
  settingsCalendarRegenerated: 'URL de calendario regenerada',
  settingsCalendarErrorSetup: 'Error al configurar el feed de calendario',
  settingsCalendarErrorRegenerate: 'Error al regenerar la URL del calendario',

  // Security / 2FA subsection
  settingsSecurityTitle: 'Autenticación de dos factores (2FA)',
  settingsSecurityDescription:
    'Protege tu cuenta con autenticación de dos factores usando una app autenticadora.',
  settingsSecurity2faEnabled: '2FA activada',
  settingsSecurity2faDisabled: '2FA desactivada',
  settingsSecurity2faEnabledText: 'Tu cuenta está protegida con autenticación de dos factores',
  settingsSecurity2faDisabledText: 'Activa 2FA para añadir una capa adicional de seguridad',
  settingsSecurityManage2faTitle: 'Gestionar 2FA',
  settingsSecurityBackupCodesTitleShort: 'Códigos de respaldo',
  settingsSecurityBackupCodesSaved: 'Tienes códigos de respaldo guardados',
  settingsSecurityBackupCodesNotSaved: 'No tienes códigos de respaldo guardados',
  settingsSecurityRegenerate: 'Regenerar',
  settingsSecurityHowToUseBackupCodesTitle: '¿Cómo usar los códigos de respaldo?',
  settingsSecurityHowToUseBackupCodesText:
    'Si pierdes acceso a tu app autenticadora, puedes usar uno de tus códigos de respaldo de 8 caracteres durante el inicio de sesión. Cada código solo puede usarse una vez. Tras usar un código, se eliminará automáticamente.',
  settingsSecurityDisable2fa: 'Desactivar 2FA',
  settingsSecuritySetup2fa: 'Configurar 2FA',
  settingsSecurityScanQrCode:
    'Escanea el código QR con tu app autenticadora (Google Authenticator, Authy, Microsoft Authenticator, etc.)',
  settingsSecurityManualCodeLabel: 'O introduce este código manualmente:',
  settingsSecurityEnterCodeLabel: 'Introduce el código de 6 dígitos de tu app autenticadora:',
  settingsSecurityVerifyAndEnable: 'Verificar y activar',
  settingsSecuritySaveNewBackupCodes: '¡Guarda estos nuevos códigos de respaldo!',
  settingsSecurityBackupCodesOnlyOnceTitle: '¡Guarda estos códigos de respaldo!',
  settingsSecurityOldCodesInvalid:
    'Los códigos anteriores ya no funcionarán. Guarda estos nuevos códigos en un lugar seguro. Solo se mostrarán una vez.',
  settingsSecurityBackupCodesOnlyOnce:
    'Estos códigos te permitirán acceder a tu cuenta si pierdes acceso a tu app autenticadora. Solo se mostrarán una vez.',
  settingsSecurityBackupCodesTitle: 'Códigos de respaldo',
  settingsSecurityDownload: 'Descargar',
  settingsSecurityCodesSavedButton: 'He guardado los códigos',
  settingsSecurityRegenerateVerifyText:
    'Para regenerar los códigos de respaldo, debes verificar tu identidad con un código de tu app autenticadora.',
  settingsSecurityVerificationCodeLabel: 'Código de verificación (6 dígitos):',
  settingsSecurityRegenerateCodes: 'Regenerar códigos',
  settingsSecurityWarningTitle: 'Advertencia',
  settingsSecurityDisableWarningText:
    'Desactivar 2FA reducirá la seguridad de tu cuenta. Asegúrate de tener guardados tus códigos de respaldo.',

  settings2faErrorSetup: 'Error al configurar 2FA',
  settings2faInvalidCode: 'Código inválido',
  settings2faEnabledSuccess: '2FA activada correctamente',
  settings2faDisabledSuccess: '2FA desactivada correctamente',
  settings2faBackupRegenerated: 'Códigos de respaldo regenerados',
  settings2faCodeRequired: 'Introduce un código de 6 dígitos',
  settings2faDisableConfirm:
    '¿Seguro que quieres desactivar 2FA? Esto reducirá la seguridad de tu cuenta.',
  settings2faRegenCodeRequired:
    'Introduce un código de 6 dígitos para regenerar los códigos de respaldo',

  // My Notification Settings Page
  myNotificationsTitle: 'Mis notificaciones',
  myNotificationsSubtitle: 'Personaliza cómo y cuándo quieres recibir notificaciones',
  myNotificationsGlobalEnabled: 'Recibirás notificaciones según tu configuración',
  myNotificationsGlobalDisabled: 'Todas las notificaciones están en pausa',
  myNotificationsChannelsTitle: 'Canales de notificación',
  myNotificationsChannelsSubtitle: 'Elige qué canales quieres usar para las notificaciones',
  myNotificationsChannelPush: 'Push',
  myNotificationsChannelPushDescription: 'Notificaciones en tiempo real',
  myNotificationsChannelEmail: 'Correo',
  myNotificationsChannelEmailDescription: 'Notificaciones por correo',
  myNotificationsChannelInApp: 'En la app',
  myNotificationsChannelInAppDescription: 'Centro de notificaciones',
  myNotificationsChannelSMS: 'SMS',
  myNotificationsChannelSMSDescription: 'Mensajes de texto',
  myNotificationsChannelWhatsApp: 'WhatsApp',
  myNotificationsChannelWhatsAppDescription: 'Mensajes de WhatsApp',
  myNotificationsChannelUnavailable: 'No disponible',
  myNotificationsEventsTitle: 'Tipos de notificación',
  myNotificationsPriorityCritical: 'Críticas',
  myNotificationsPriorityHigh: 'Importantes',
  myNotificationsEventDisabledByAdmin: 'Deshabilitado por el administrador',
  myNotificationsQuietHoursTitle: 'Horas de silencio',
  myNotificationsQuietHoursSubtitle: 'No recibir notificaciones push durante estas horas',

  // Notification Settings Page (admin)
  notificationSettingsTitle: 'Ajustes de notificaciones',
  notificationSettingsSubtitle: 'Elige cómo quieres recibir notificaciones para cada tipo de evento',
  notificationSettingsInfoTitle: 'Canales de notificación',
  notificationSettingsInfoText:
    'Correo y Push están incluidos en tu plan. WhatsApp y SMS son servicios premium que requieren configuración adicional.',
  notificationSettingsChannelsTitle: 'Canales disponibles',
  notificationSettingsChannelEmail: 'Correo de la organización',
  notificationSettingsChannelEmailDescription: 'Usando tu servidor SMTP',
  notificationSettingsChannelWhatsApp: 'WhatsApp Business',
  notificationSettingsChannelWhatsAppDescription: 'Vía API de Twilio',
  notificationSettingsChannelSMS: 'SMS',
  notificationSettingsChannelSMSDescription: 'Mensajes de texto',
  notificationSettingsChannelPush: 'Notificaciones push',
  notificationSettingsChannelPushDescription: 'Navegador / móvil',
  notificationSettingsChannelInApp: 'En la app',
  notificationSettingsChannelInAppDescription: 'Siempre activo',
  notificationSettingsMonthlyCost: '€{{amount}}/mes',
  notificationSettingsConfigured: 'Configurado',
  notificationSettingsRequires: 'Requiere: {{requires}}',
  notificationSettingsWhatsAppTitle: 'Configurar WhatsApp Business',
  notificationSettingsTwilioSidLabel: 'SID de cuenta de Twilio',
  notificationSettingsTwilioTokenLabel: 'Token de autenticación de Twilio',
  notificationSettingsWhatsAppNumberLabel: 'Número de WhatsApp (con código de país)',
  notificationSettingsWhatsAppNumberHelp:
    'Número de sandbox de Twilio o tu número de WhatsApp Business aprobado',
  notificationSettingsWhatsAppSaved: 'Configuración guardada. Envía un mensaje de prueba para activar.',
  notificationSettingsTestTitle: 'Probar configuración',
  notificationSettingsTestPhoneRequired: 'Introduce un número de teléfono para la prueba',
  notificationSettingsSendTest: 'Enviar prueba',
  notificationSettingsWhatsAppTestSuccess: '¡WhatsApp activado correctamente!',
  notificationSettingsWhatsAppTestError: 'Error durante la prueba',
  notificationSettingsWhatsAppSandboxHint:
    'El número de destino debe enviar primero "join [sandbox-code]" al número de Twilio',
  notificationSettingsSetupTitle: '¿Cómo configurarlo?',
  notificationSettingsSetupStep1: 'Crea una cuenta en',
  notificationSettingsSetupStep2:
    'Activa el sandbox de WhatsApp o solicita un número de WhatsApp Business',
  notificationSettingsSetupStep3: 'Copia tus credenciales desde la consola de Twilio',
  notificationSettingsSetupStep4: 'Envía un mensaje de prueba para verificar',
  notificationSettingsViewDocs: 'Ver documentación',
  notificationSettingsEmailHint:
    'El correo se configura en la sección de SMTP de la organización.',
  notificationSettingsGoToSmtp: 'Ir a ajustes SMTP',
  notificationSettingsEventsTitle: 'Configurar por evento',
  notificationSettingsEventsSubtitle: 'Selecciona qué canales usar para cada tipo de notificación',
  notificationSettingsEventShiftAssigned: 'Turno asignado',
  notificationSettingsEventShiftAssignedDescription: 'Cuando se asigna un turno al empleado',
  notificationSettingsEventShiftReminder: 'Recordatorio de turno',
  notificationSettingsEventShiftReminderDescription: 'Antes de que empiece el turno',
  notificationSettingsEventShiftCancelled: 'Turno cancelado',
  notificationSettingsEventShiftCancelledDescription: 'Cuando se cancela un turno',
  notificationSettingsEventSwapRequest: 'Solicitud de cambio',
  notificationSettingsEventSwapRequestDescription: 'Cuando alguien solicita cambiar un turno',
  notificationSettingsEventSwapApproved: 'Cambio aprobado',
  notificationSettingsEventSwapApprovedDescription: 'Cuando se aprueba un cambio',
  notificationSettingsEventSwapRejected: 'Cambio rechazado',
  notificationSettingsEventSwapRejectedDescription: 'Cuando se rechaza un cambio',
  notificationSettingsEventSchedulePublished: 'Horario publicado',
  notificationSettingsEventSchedulePublishedDescription: 'Cuando se publica el nuevo horario',
  notificationSettingsEventRuleViolation: 'Infracción de regla',
  notificationSettingsEventRuleViolationDescription: 'Alertas de cumplimiento',
  notificationSettingsActivateChannelFirst:
    'Primero activa el canal {{channel}} para usarlo en este evento.',
  notificationSettingsPricingTitle: 'Costes del servicio',
  notificationSettingsIncluded: 'Incluido',
  notificationSettingsServiceMonthly: '€{{amount}}/mes',

  // Marketplace Page
  marketplaceTitle: 'Marketplace',
  marketplaceSubtitle: 'Beneficios exclusivos, turnos extra y anticipos de salario',
  marketplaceTabPerks: 'Beneficios y descuentos',
  marketplaceTabListings: 'Mercado de turnos',
  marketplaceTabAdvance: 'Anticipo de salario',
  marketplaceOverviewPartners: 'Socios',
  marketplaceOverviewActiveOffers: 'Ofertas activas',
  marketplaceOverviewFeatured: 'Destacadas',
  marketplaceOverviewMyRedemptions: 'Mis canjes',
  marketplaceSearchPlaceholder: 'Buscar ofertas...',
  marketplaceAllCategories: 'Todas las categorías',
  marketplaceCategoryFoodBeverage: 'Comida y bebida',
  marketplaceCategoryWellnessFitness: 'Bienestar y fitness',
  marketplaceCategoryEntertainment: 'Entretenimiento',
  marketplaceCategoryRetailShopping: 'Compras',
  marketplaceCategoryTravelTransport: 'Viajes y transporte',
  marketplaceCategoryEducationTraining: 'Educación',
  marketplaceCategoryFinanceInsurance: 'Finanzas y seguros',
  marketplaceCategoryTechnology: 'Tecnología',
  marketplaceCategoryHealthMedical: 'Salud',
  marketplaceCategoryOther: 'Otros',
  marketplacePerkFeatured: 'DESTACADO',
  marketplaceDiscountPercentage: '-{{value}}%',
  marketplaceDiscountFixed: '-${{value}}',
  marketplaceDiscountFree: '¡GRATIS!',
  marketplaceRedeemOffer: 'Canjear oferta',
  marketplaceNoOffersTitle: 'No hay ofertas disponibles',
  marketplaceNoOffersSubtitle: 'Pronto habrá beneficios exclusivos para ti.',
  marketplaceSeedDemo: 'Cargar demo de partners',
  marketplaceRedeemError: 'Error al canjear la oferta',
  marketplaceDemoCreated:
    'Demo creada: {{partners}} partners, {{perks}} beneficios',
  marketplaceDemoLoaded: 'Demo cargada',
  marketplaceApplySuccess: '¡Solicitud enviada correctamente!',
  marketplaceApplyError: 'Error al solicitar',
  marketplaceListingsTitle: 'Mercado de turnos',
  marketplaceListingsSubtitle:
    'Cubre turnos de otras organizaciones y gana dinero extra. ¡Genial para ingresos adicionales!',
  marketplaceListingUrgent: 'URGENTE - BONUS de ${{bonus}}',
  marketplaceListingRate: '${{rate}}/h',
  marketplaceNoListingsTitle: 'No hay turnos disponibles',
  marketplaceNoListingsSubtitle: '¡Vuelve más tarde para nuevas oportunidades!',
  marketplaceAdvanceMinError: 'El anticipo mínimo es de $20',
  marketplaceAdvanceSuccess:
    '¡Se transferirá un anticipo de ${{amount}}!',
  marketplaceAdvanceError: 'Error al solicitar anticipo',
  marketplaceAdvanceAvailableTitle: 'Disponible para anticipo',
  marketplaceAdvanceAvailableAmount: '${{amount}}',
  marketplaceAdvanceBasedOn:
    'Basado en ${{wages}} de salarios ganados ({{hours}} horas trabajadas)',
  marketplaceAdvanceMaxTitle: 'Anticipo máximo',
  marketplaceAdvanceFee: 'Comisión: {{fee}}%',
  marketplaceAdvanceRequestTitle: 'Solicitar anticipo',
  marketplaceAdvanceAmountLabel: 'Importe (mín. ${{min}})',
  marketplaceAdvanceInstantTransfer: 'Transferencia instantánea',
  marketplaceAdvanceBreakdown:
    'Comisión: ${{feeAmount}} | Recibirás: ${{netAmount}}',
  marketplaceAdvanceHistoryTitle: 'Historial de anticipos',
  marketplaceAdvanceHistoryRow: '${{amount}} solicitados',
  marketplaceAdvanceHistoryNet: '${{amount}} recibidos',
  marketplaceAdvanceHistoryEmpty: 'Aún no tienes historial de anticipos',
  marketplaceCodeLabel: 'Tu código:',
  marketplaceGoRedeem: 'Ir a canjear',
  marketplaceInstructionsLabel: 'Instrucciones:',

  // Labor Rules Page
  laborRulesTitle: 'Reglas laborales',
  laborRulesSubtitle: 'Configura las reglas laborales de tu organización',
  laborRulesSaveSuccess: 'Reglas laborales guardadas correctamente',
  laborRulesSaveError: 'Error al guardar las reglas laborales',
  laborRulesBaseTemplateTitle: 'Plantilla base',
  laborRulesBaseTemplateDescription:
    'Selecciona una plantilla según la legislación de un país o personaliza completamente las reglas.',
  laborRulesTimeLimitsTitle: 'Límites de tiempo',
  laborRulesMultipliersTitle: 'Multiplicadores de coste',
  laborRulesNightHoursTitle: 'Horario nocturno',
  laborRulesMaxDailyHoursLabel: 'Máximo de horas diarias',
  laborRulesMaxDailyHoursDescription:
    'Máximo de horas por turno (0 = sin límite)',
  laborRulesMaxWeeklyHoursLabel: 'Máximo de horas semanales',
  laborRulesMaxWeeklyHoursDescription: 'Máximo de horas por semana',
  laborRulesMaxAnnualOvertimeLabel: 'Máximo anual de horas extra',
  laborRulesMaxAnnualOvertimeDescription:
    'Máximo de horas extra por año (0 = sin límite)',
  laborRulesMinRestBetweenShiftsLabel: 'Descanso mínimo entre turnos',
  laborRulesMinRestBetweenShiftsDescription:
    'Horas mínimas de descanso entre turnos',
  laborRulesMinWeeklyRestLabel: 'Descanso semanal mínimo',
  laborRulesMinWeeklyRestDescription:
    'Horas mínimas de descanso por semana',
  laborRulesMaxConsecutiveDaysLabel: 'Máximo de días consecutivos',
  laborRulesMaxConsecutiveDaysDescription:
    'Número máximo de días trabajados seguidos',
  laborRulesMaxNightShiftsLabel: 'Máximo de turnos nocturnos consecutivos',
  laborRulesMaxNightShiftsDescription:
    'Turnos nocturnos consecutivos (0 = sin límite)',
  laborRulesUnitHoursShort: 'h',
  laborRulesUnitDays: 'días',
  laborRulesUnitNights: 'noches',
  laborRulesOvertimeMultiplierLabel: 'Multiplicador de horas extra',
  laborRulesOvertimeMultiplierDescription: 'Ej.: 1.5 = +50%',
  laborRulesNightMultiplierLabel: 'Multiplicador nocturno',
  laborRulesNightMultiplierDescription: 'Bonus por turnos nocturnos',
  laborRulesWeekendMultiplierLabel: 'Multiplicador de fin de semana',
  laborRulesWeekendMultiplierDescription: 'Bonus por sábado/domingo',
  laborRulesHolidayMultiplierLabel: 'Multiplicador de festivos',
  laborRulesHolidayMultiplierDescription: 'Bonus por festivos',
  laborRulesNightStartLabel: 'Inicio',
  laborRulesNightEndLabel: 'Fin',
  laborRulesViolationsTitle: 'Infracciones detectadas',
  laborRulesViolationsOpenCount: '{{count}} abiertas',
  laborRulesNoViolationsTitle: 'No se detectaron infracciones',
  laborRulesNoViolationsSubtitle: 'Todos los turnos cumplen las reglas configuradas',

  // Integrations Page
  integrationsTitle: 'Integraciones',
  integrationsSubtitle: 'Configura tus claves de API de terceros',
  integrationsSensitiveInfoTitle: 'Información sensible',
  integrationsSensitiveInfoText:
    'Las claves de API se almacenan de forma segura y nunca se muestran completas después de guardarlas. Solo el Super Admin puede modificar estos ajustes.',
  integrationsSaveSuccess: '¡Configuración guardada correctamente!',
  integrationsSaveError: 'Error al guardar la configuración',
  integrationsSaveButton: 'Guardar configuración',
  integrationsStripeDescription: 'Procesamiento de pagos',
  integrationsStripePublishableKeyLabel: 'Clave publicable (pk_...)',
  integrationsStripePublishableKeyPlaceholder: 'pk_live_... o pk_test_...',
  integrationsStripeSecretKeyLabel: 'Clave secreta (sk_...)',
  integrationsStripeSecretKeyPlaceholder: 'sk_live_... o sk_test_...',
  integrationsStripeGetKeys: 'Obtén tus claves en',
  integrationsTestConnection: 'Probar conexión',
  integrationsStripeTestError: 'Error al probar Stripe',
  integrationsAiTitle: 'Inteligencia artificial',
  integrationsAiSubtitle: 'Asignación automática de turnos',
  integrationsAiProviderLabel: 'Proveedor de IA',
  integrationsAiModelLabel: 'Modelo',
  integrationsAiApiKeyLabel: 'Clave de API',
  integrationsAiTestError: 'Error al probar la IA',
  integrationsCalendarTitle: 'Integraciones de calendario',
  integrationsCalendarSubtitle:
    'Sincroniza tus turnos con Google Calendar y Microsoft Outlook/Teams',
  integrationsCalendarConnected:
    '¡{{provider}} conectado correctamente! {{email}}',
  integrationsCalendarConnectError: 'Error al conectar el calendario: {{error}}',
  integrationsCalendarStartError: 'Error al iniciar la conexión del calendario',
  integrationsCalendarDisconnectConfirm:
    '¿Quieres desconectar {{provider}}?',
  integrationsCalendarDisconnected: '{{provider}} desconectado',
  integrationsCalendarDisconnectError: 'Error al desconectar el calendario',
  integrationsCalendarConnectedAs: 'Conectado como: {{email}}',
  integrationsCalendarSyncLabel: 'Sincronización: {{status}}',
  integrationsCalendarHowToTitle: '¿Cómo configurar las integraciones de calendario?',
  integrationsGoogleDescription: 'Sincronizar eventos y turnos',
  integrationsGoogleConnectText:
    'Conecta tu Google Calendar para sincronizar automáticamente tus turnos de trabajo.',
  integrationsGoogleBenefitUnified: 'Ver todos tus eventos en un solo lugar',
  integrationsGoogleBenefitBidirectional: 'Sincronización bidireccional',
  integrationsGoogleNotConfigured:
    'Google Calendar no está configurado en el servidor. Contacta con el administrador.',
  integrationsGoogleConnectButton: 'Conectar Google Calendar',
  integrationsMicrosoftTitle: 'Microsoft Outlook y Teams',
  integrationsMicrosoftDescription: 'Calendario y reuniones de Teams',
  integrationsMicrosoftConnectText:
    'Conecta tu cuenta de Microsoft para sincronizar el calendario de Outlook y crear automáticamente reuniones de Teams.',
  integrationsMicrosoftBenefitOutlook: 'Sincronizar con Outlook Calendar',
  integrationsMicrosoftBenefitTeams: 'Crear automáticamente reuniones de Teams',
  integrationsMicrosoftBenefitBidirectional: 'Sincronización bidireccional',
  integrationsMicrosoftNotConfigured:
    'Microsoft no está configurado en el servidor. Contacta con el administrador.',
  integrationsMicrosoftConnectButton: 'Conectar Microsoft',
  integrationsCalendarGoogleStep1: 'Ir a',
  integrationsCalendarGoogleStep2: 'Habilita la API de Google Calendar',
  integrationsCalendarGoogleStep3: 'Crea credenciales OAuth 2.0',
  integrationsCalendarGoogleStep4: 'Establece las variables de entorno:',
  integrationsCalendarMicrosoftStep1: 'Ir a',
  integrationsCalendarMicrosoftStep2: 'Registrar una aplicación en Azure AD',
  integrationsCalendarMicrosoftStep3:
    'Añade permisos: Calendars.ReadWrite, User.Read',
  integrationsCalendarMicrosoftStep4: 'Establece las variables de entorno:',

  // Incentives Page
  incentivesTitle: 'Incentivos y recompensas',
  incentivesSubtitle: 'Gana puntos por tu rendimiento y canjéalos por recompensas',
  incentivesMyTotalPoints: 'Mis puntos totales',
  incentivesCurrentRanking: 'Clasificación actual',
  incentivesTabHistory: 'Historial',
  incentivesTabRanking: 'Ranking',
  incentivesTabStore: 'Tienda',
  incentivesTabMyClaims: 'Mis canjes',
  incentivesNoPointsTitle: 'Aún no hay puntos',
  incentivesNoPointsSubtitle: 'Gana puntos siendo puntual y aceptando turnos extra',
  incentivesNoRankingTitle: 'No hay datos de ranking',
  incentivesNoRankingSubtitle: 'El ranking se generará cuando se registren puntos',
  incentivesYouLabel: 'Tú',
  incentivesEmployeeLabel: 'Empleado #{{rank}}',
  incentivesNoRewardsTitle: 'No hay recompensas disponibles',
  incentivesNoRewardsSubtitle: 'El administrador no ha configurado recompensas aún',
  incentivesRewardAvailableCount: '{{count}} disponibles',
  incentivesRewardNotEnoughPoints: 'No tienes suficientes puntos',
  incentivesRewardSoldOut: 'Agotado',
  incentivesRewardClaimButton: 'Canjear',
  incentivesRewardClaimed: 'Recompensa canjeada',
  incentivesRewardClaimError: 'Error al canjear la recompensa',
  incentivesNoClaimsTitle: 'Sin canjes',
  incentivesNoClaimsSubtitle: 'Aún no has canjeado ninguna recompensa',
  incentivesClaimPointsSpent: '{{points}} puntos',
  incentivesActiveProgramsTitle: 'Programas activos',

  // Geofencing Page
  geofencingTitle: 'Geocercas',
  geofencingSubtitle: 'Controla la asistencia por ubicación',
  geofencingNewLocationButton: 'Nueva ubicación',
  geofencingCurrentLocationTitle: 'Tu ubicación actual',
  geofencingCheckInZoneButton: 'Comprobar si estoy en la zona',
  geofencingEnableLocationHint:
    'Activa la ubicación en tu navegador para usar geocercas',
  geofencingLocationUnavailable: 'No se pudo obtener tu ubicación',
  geofencingCheckError: 'Error al comprobar la ubicación',
  geofencingEditLocationTitle: 'Editar ubicación',
  geofencingNewLocationTitle: 'Nueva ubicación',
  geofencingNameLabel: 'Nombre',
  geofencingNamePlaceholder: 'p. ej., Sede central',
  geofencingAddressLabel: 'Dirección',
  geofencingAddressPlaceholder: 'Calle, número, ciudad',
  geofencingUseCurrentLocation: 'Usar mi ubicación actual',
  geofencingRadiusLabel: 'Radio (metros)',
  geofencingRadiusShortLabel: 'Radio',
  geofencingRadiusHelp: 'Distancia máxima permitida desde el punto central',
  geofencingPrimaryLocationLabel: 'Ubicación principal',
  geofencingPrimaryLocationHelp:
    'Se usará por defecto para verificaciones',
  geofencingNoLocationsTitle: 'Sin ubicaciones',
  geofencingNoLocationsSubtitle:
    'Añade ubicaciones para controlar dónde pueden fichar tus empleados',
  geofencingAddFirstLocation: 'Añadir primera ubicación',
  geofencingPrimaryLocationBadge: 'Ubicación principal',
  geofencingNoAddress: 'Sin dirección',
  geofencingCoordinatesLabel: 'Coordenadas',
  geofencingMissingFieldsError: 'Completa todos los campos obligatorios',
  geofencingLocationUpdated: 'Ubicación actualizada',
  geofencingLocationCreated: 'Ubicación creada',
  geofencingSaveError: 'Error al guardar la ubicación',
  geofencingDeleteConfirm: '¿Eliminar esta ubicación?',
  geofencingLocationDeleted: 'Ubicación eliminada',
  geofencingDeleteError: 'Error al eliminar la ubicación',
  geofencingInsideArea: 'Dentro del área permitida',
  geofencingInsideAreaDetail: '{{name}} - a {{distance}}m del centro',
  geofencingOutsideArea: 'Fuera del área permitida',

  // Gamification Settings Page
  gamificationSettingsTitle: 'Ajustes de gamificación',
  gamificationSettingsSubtitle: 'Configura rankings, puntos, recompensas y retos semanales',
  gamificationSettingsSaved: 'Ajustes de gamificación guardados',
  gamificationSettingsSaveError: 'Error al guardar los ajustes de gamificación',
  gamificationSettingsEnabled: 'Gamificación activada',
  gamificationSettingsDisabled: 'Gamificación desactivada',
  gamificationSettingsEnabledDescription:
    'Los empleados pueden ganar puntos y competir por recompensas',
  gamificationSettingsDisabledDescription:
    'La gamificación está desactivada en esta organización',
  gamificationSettingsParticipationTotal: 'Total',
  gamificationSettingsParticipationConsented: 'Participando',
  gamificationSettingsParticipationOptedOut: 'No participan',
  gamificationSettingsParticipationRate: 'Participación',
  gamificationSettingsRankingTitle: 'Configuración del ranking',
  gamificationSettingsRankingEnableLabel: 'Activar ranking',
  gamificationSettingsRankingEnableDescription: 'Mostrar tabla de clasificación de empleados',
  gamificationSettingsRankingPeriodLabel: 'Periodo del ranking',
  gamificationSettingsRankingVisibleLabel: 'Visible para todos',
  gamificationSettingsRankingAnonymousLabel: 'Ranking anónimo',
  gamificationSettingsPointsTitle: 'Sistema de puntos',
  gamificationSettingsPointsOnTimeLabel: 'Puntos por fichar a tiempo',
  gamificationSettingsPointsPerfectWeekLabel: 'Puntos por semana perfecta',
  gamificationSettingsBonusStreakDaysLabel: 'Días para bonus por racha',
  gamificationSettingsBonusStreakPointsLabel: 'Puntos de bonus por racha',
  gamificationSettingsChallengesTitle: 'Retos semanales ({{count}})',
  gamificationSettingsAddChallengeButton: 'Añadir reto',
  gamificationSettingsRewardsTitle: 'Recompensas ({{count}})',
  gamificationSettingsAddRewardButton: 'Añadir recompensa',
  gamificationSettingsRewardPositionLine:
    'Posición {{position}}° • {{value}}',
  gamificationSettingsGdprTitle: 'Privacidad y GDPR',
  gamificationSettingsGdprInfo:
    'Cumplimiento GDPR: Los empleados deben dar consentimiento explícito para participar. Pueden darse de baja en cualquier momento y solicitar la eliminación de sus datos.',
  gamificationSettingsGdprRequireConsentLabel: 'Requerir consentimiento',
  gamificationSettingsGdprRequireConsentDesc:
    'Los empleados deben aceptar para participar',
  gamificationSettingsGdprAllowOptOutLabel: 'Permitir baja',
  gamificationSettingsGdprAllowOptOutDesc:
    'Los empleados pueden abandonar el programa',
  gamificationSettingsGdprAnonymizeAfterPeriodLabel: 'Anonimizar datos antiguos',
  gamificationSettingsGdprAnonymizeAfterPeriodDesc:
    'Tras el periodo de retención',
  gamificationSettingsGdprRetentionLabel: 'Retención de datos (días)',
  gamificationSettingsNewRewardTitle: 'Nueva recompensa',
  gamificationSettingsRewardNameLabel: 'Nombre de la recompensa',
  gamificationSettingsRewardNamePlaceholder: 'p. ej., Empleado del mes',
  gamificationSettingsRewardDescriptionPlaceholder:
    'p. ej., Mejor puntualidad del mes',
  gamificationSettingsRewardValuePlaceholder: 'p. ej., 1 día libre, €50',
  gamificationSettingsNewChallengeTitle: 'Nuevo reto',
  gamificationSettingsChallengeNameLabel: 'Nombre del reto',
  gamificationSettingsChallengeNamePlaceholder: 'p. ej., Puntualidad perfecta',
  gamificationSettingsChallengeDescriptionPlaceholder:
    'p. ej., Fichar a tiempo 5 días seguidos',
  gamificationSettingsChallengeTargetLabel: 'Objetivo',
  gamificationSettingsChallengeRewardPointsLabel: 'Puntos de recompensa',
  gamificationSettingsRewardAdded: 'Recompensa añadida',
  gamificationSettingsRewardAddError: 'Error al añadir la recompensa',
  gamificationSettingsRewardDeleted: 'Recompensa eliminada',
  gamificationSettingsChallengesUpdated: 'Retos actualizados',
  gamificationSettingsChallengesSaveError: 'Error al guardar los retos',

  // Employee Onboarding Page
  onboardingTitle: 'Incorporación automatizada',
  onboardingSubtitle:
    'Contrata a nuevos empleados con un clic: Escaneo OCR → Contrato → Firma digital',
  onboardingNewHireButton: 'Nuevo empleado',
  onboardingStatTotalFlows: 'Procesos totales',
  onboardingStatPending: 'Pendientes',
  onboardingStatAwaitingSignature: 'Pendientes de firma',
  onboardingStatCompleted: 'Completados',
  onboardingTabNew: 'Nuevo empleado',
  onboardingTabActive: 'En progreso',
  onboardingTabCompleted: 'Completados',
  onboardingStatusPendingIdScan: 'Escaneo pendiente',
  onboardingStatusPendingReview: 'En revisión',
  onboardingStatusPendingContract: 'Generar contrato',
  onboardingStatusPendingSignature: 'Enviar para firma',
  onboardingStatusAwaitingSignature: 'Pendiente de firma',
  onboardingSettingsSaved: 'Ajustes de incorporación guardados',
  onboardingNoFlowsTitle: 'Sin procesos',
  onboardingNoCompletedFlows: 'Sin procesos completados',
  onboardingNoActiveFlows: 'Sin procesos activos',
  onboardingOneClickTitle: 'Contratación con un clic',
  onboardingEmployeeEmailLabel: 'Correo del empleado',
  onboardingEmployeeEmailPlaceholder: 'nuevo.empleado@empresa.com',
  onboardingEmployeeNameLabel: 'Nombre del empleado (opcional)',
  onboardingEmployeeNamePlaceholder: 'Se extraerá del documento de identidad',
  onboardingTemplateLabel: 'Plantilla de contrato',
  onboardingTemplatePlaceholder: 'Selecciona una plantilla...',
  onboardingDocumentTypeLabel: 'Tipo de documento',
  onboardingDocTypeDni: 'DNI (España)',
  onboardingDocTypeNie: 'NIE (España)',
  onboardingDocTypePassport: 'Pasaporte',
  onboardingDocTypeDriverLicense: 'Carnet de conducir',
  onboardingDocumentCountryLabel: 'País del documento',
  countryES: 'España',
  countryUS: 'Estados Unidos',
  countryFR: 'Francia',
  countryDE: 'Alemania',
  countryUK: 'Reino Unido',
  onboardingIdDocumentLabel: 'Documento de identidad',
  onboardingUploadIdButton: 'Subir foto del documento',
  onboardingHumanReviewEnabledInfo:
    'La revisión humana está activada. El contrato requerirá aprobación antes de enviarse.',
  onboardingProcessingOcr: 'Procesando OCR...',
  onboardingStartButton: 'Iniciar incorporación',
  onboardingResultTitle: 'Resultado del proceso',
  onboardingResultFlowId: 'ID del proceso: {{id}}',
  onboardingExtractedDataTitle: 'Datos extraídos (OCR)',
  onboardingNextStepsTitle: 'Siguientes pasos',
  onboardingNextStepsReview:
    'Ve a la pestaña "En progreso" para revisar y aprobar los datos extraídos.',
  onboardingNextStepsAutoSent:
    'El contrato se ha enviado automáticamente para firma.',
  onboardingNextStepsSendForSignature:
    'Ve a la pestaña "En progreso" para enviar el contrato a firma.',
  onboardingEmptyResultTitle: 'Rellena el formulario y sube el documento',
  onboardingEmptyResultSubtitle: 'Aquí aparecerán los resultados',
  onboardingSettingsTitle: 'Ajustes de incorporación',
  onboardingSettingsHumanReviewLabel: 'Requerir revisión humana',
  onboardingSettingsHumanReviewDescription:
    'Los datos de OCR deben aprobarse antes de generar el contrato',
  onboardingSettingsAutoSendLabel: 'Envío automático a firma',
  onboardingSettingsAutoSendDescription:
    'Enviar el contrato automáticamente después de generarlo',
  onboardingSettingsDefaultTemplateLabel: 'Plantilla por defecto',
  onboardingSettingsDefaultTemplateNone: 'Ninguna (seleccionar cada vez)',
  onboardingSettingsDefaultCountryLabel: 'País por defecto',
  onboardingSettingsOcrThresholdLabel: 'Umbral de confianza OCR: {{value}}%',
  onboardingFlowDetailTitle: 'Proceso de incorporación',
  onboardingApproveSuccess: 'Datos aprobados',
  onboardingApproveError: 'Error al aprobar los datos',
  onboardingGenerateContractSuccess: 'Contrato generado',
  onboardingGenerateContractError: 'Error al generar el contrato',
  onboardingSendForSignatureSuccess: 'Contrato enviado para firma',
  onboardingSendForSignatureError: 'Error al enviar para firma',
  onboardingApproveAndContinueButton: 'Aprobar y continuar',
  onboardingGenerateContractButton: 'Generar contrato',
  onboardingSendForSignatureButton: 'Enviar para firma',

  // Employee Credits Page
  employeeCreditsTitle: 'Mis créditos de Aria',
  employeeCreditsSubtitle: 'Gestiona tus créditos para usar el asistente personal de IA',
  employeeCreditsBalanceLabel: 'Tu saldo',
  employeeCreditsCreditsUnit: 'créditos',
  employeeCreditsTotalPurchased: 'Total comprado',
  employeeCreditsTotalUsed: 'Total usado',
  employeeCreditsPurchasesDisabledTitle: 'Compras desactivadas',
  employeeCreditsPurchasesDisabledText:
    'Tu organización no permite que los empleados compren créditos directamente. Contacta con tu administrador si necesitas más créditos.',
  employeeCreditsPurchasesDisabledOrg:
    'Tu organización no permite comprar créditos a los empleados',
  employeeCreditsMonthlyLimitLine:
    'Límite mensual: {{limit}} créditos',
  employeeCreditsRequiresApprovalSuffix:
    ' • Requiere aprobación del responsable',
  employeeCreditsBuyTitle: 'Comprar créditos',
  employeeCreditsPopularBadge: 'Popular',
  employeeCreditsSaveBadge: 'Ahorra {{save}}',
  employeeCreditsBuyButton: 'Comprar',
  employeeCreditsCreateSessionError: 'Error al crear la sesión de pago',
  employeeCreditsWhatForTitle: '¿Para qué sirven los créditos?',
  employeeCreditsUseChatTitle: 'Chatea con Aria',
  employeeCreditsUseChatText:
    'Chatea con tu asistente personal para preguntas sobre turnos, políticas, etc.',
  employeeCreditsUseChatCost: '~1 crédito por mensaje',
  employeeCreditsUseAnalysisTitle: 'Análisis personalizado',
  employeeCreditsUseAnalysisText:
    'Obtén insights sobre tus patrones de trabajo y sugerencias de mejora.',
  employeeCreditsUseAnalysisCost: '~5 créditos por análisis',
  employeeCreditsUseAvatarTitle: 'Avatar animado',
  employeeCreditsUseAvatarText:
    'Interactúa con Aria mediante un avatar 3D animado en tiempo real.',
  employeeCreditsUseAvatarCost: '~3 créditos por minuto',
  employeeCreditsPaymentsInfo:
    'Todos los pagos se procesan de forma segura en {{host}}',
  employeeCreditsPaymentsMethods:
    'Aceptamos Visa, Mastercard, American Express y PayPal',

  // ERP Page
  erpLoadError: 'Error al cargar los datos del ERP',
  erpSaveError: 'Error al guardar los datos del ERP',
  erpTitle: 'ERP Premium',
  erpSubtitle: 'ERP avanzado para tu organización',
  erpNewExpenseButton: 'Nuevo gasto',

  erpUpgradeTitle: 'ERP Enterprise',
  erpUpgradeDescription:
    'El módulo ERP requiere un plan Enterprise para acceso completo a recursos financieros y de planificación.',
  erpUpgradeViewPlans: 'Ver planes',

  erpTabDashboard: 'Panel',
  erpTabExpenses: 'Gastos',
  erpTabInventory: 'Inventario',
  erpTabSuppliers: 'Proveedores',
  erpTabOrders: 'Pedidos',
  erpTabCostCenters: 'Centros de coste',
  erpTabIntegration: 'Integración',
  erpTabReports: 'Informes',

  erpCategoryOperational: 'Operativo',
  erpCategoryPayroll: 'Nómina',
  erpCategoryEquipment: 'Equipamiento',
  erpCategoryTravel: 'Viajes',
  erpCategoryOther: 'Otros',

  erpPremiumInventoryLine:
    '{{items}} artículos • {{alerts}} alertas de stock bajo',
  erpPremiumCostCentersLabel: 'Centros de coste',
  erpPremiumCostCentersCount: '{{count}} centros',
  erpPremiumPendingOrdersLabel: 'Pedidos pendientes',
  erpPremiumSuppliersCount: '{{count}} proveedores',
  erpPremiumIntegrationLabel: 'Integración',
  erpPremiumIntegrationDefaultProvider: 'Rostafy ERP',

  erpKpiEmployeesActive: 'Empleados activos',
  erpKpiEmployeesHours: '{{hours}}h trabajadas',
  erpKpiLaborCost: 'Coste laboral',
  erpKpiThisMonth: 'este mes',
  erpKpiExpenses: 'Gastos',
  erpKpiExpensesCount: '{{count}} registros',
  erpKpiPeriod: 'Periodo',
  erpKpiCurrentMonth: 'Mes actual',

  erpCostBreakdownTitle: 'Desglose de costes',
  erpCostLaborLabel: 'Laboral',
  erpCostOtherExpensesLabel: 'Otros gastos',

  erpKeyMetricsTitle: 'Métricas clave',
  erpMetricCostPerEmployee: 'Coste por empleado',
  erpMetricCostPerHour: 'Coste por hora',
  erpMetricAvgHoursPerEmployee: 'Horas medias/empleado',

  erpNoExpenses: 'No hay gastos registrados',
  erpRegisterFirstExpense: 'Registrar primer gasto',
  erpExpensesDescriptionHeader: 'Descripción',
  erpExpensesCategoryHeader: 'Categoría',
  erpExpensesDateHeader: 'Fecha',
  erpExpensesAmountHeader: 'Importe',

  erpInventoryTotalValueLabel: 'Valor total',
  erpInventoryLowStockLabel: 'Stock bajo',
  erpInventoryLowStockCount: '{{count}} artículos',
  erpInventoryNewItemButton: 'Nuevo artículo',
  erpInventoryEmpty: 'No hay artículos en inventario',
  erpInventoryProductHeader: 'Producto',
  erpInventorySkuHeader: 'SKU',
  erpInventoryQuantityHeader: 'Cantidad',
  erpInventoryValueHeader: 'Valor',

  erpSuppliersNewButton: 'Nuevo proveedor',
  erpSuppliersEmpty: 'No hay proveedores registrados',
  erpSuppliersPaymentTerms: 'Condiciones: {{days}} días',

  erpOrdersEmpty: 'No hay órdenes de compra',
  erpOrdersItemsCount: '{{count}} artículos',

  erpCostCentersNewButton: 'Nuevo centro de coste',
  erpCostCentersEmpty: 'No hay centros de coste',
  erpCostCentersUtilizationBadge: '{{value}}% usado',
  erpCostCentersBudgetLabel: 'Presupuesto',
  erpCostCentersSpentLabel: 'Gastado: €{{amount}}',
  erpCostCentersRemainingLabel: 'Restante: €{{amount}}',

  erpIntegrationTitle: 'Ajustes de integración del ERP',
  erpIntegrationCurrentModeLabel: 'Modo actual',
  erpIntegrationExternalConnected: 'Conectado a {{provider}}',
  erpIntegrationInternalMode: 'Usando el ERP interno de Rostafy',
  erpIntegrationExternalTitle: 'Conectar ERP externo',
  erpIntegrationConnectWithProvider: 'Conectar con {{provider}}',
  erpIntegrationNoErpTitle: '¿No tienes un ERP? Usa el nuestro',
  erpIntegrationNoErpDescription:
    'El ERP integrado de Rostafy incluye todas las funciones premium sin configuración adicional.',

  erpReportMonthlySummaryTitle: 'Resumen mensual',
  erpReportMonthlySummaryDescription:
    'Costes laborales y gastos del mes',
  erpReportExpenseAnalysisTitle: 'Análisis de gastos',
  erpReportExpenseAnalysisDescription: 'Desglose por categoría',
  erpReportFinancialProjectionTitle: 'Proyección financiera',
  erpReportFinancialProjectionDescription:
    'Estimación para el próximo trimestre',
  erpReportInventoryTitle: 'Inventario',
  erpReportInventoryDescription: 'Valoración y movimientos',
  erpReportCostCentersTitle: 'Coste por centro',
  erpReportCostCentersDescription: 'Análisis por centro de coste',
  erpReportBalanceTitle: 'Balance',
  erpReportBalanceDescription: 'Estado financiero completo',
  erpReportGenerateButton: 'Generar',

  // Domains Page
  domainsLoadError: 'Error al cargar los dominios',
  domainsAddError: 'Error al añadir el dominio',
  domainsVerifyError:
    'Error al verificar el dominio. Asegúrate de que los registros DNS estén configurados correctamente.',
  domainsRemoveError: 'Error al eliminar el dominio',
  domainsDeleteConfirm: '¿Eliminar el dominio {{domain}}?',

  domainsTitle: 'Dominios personalizados',
  domainsSubtitle: 'Configura tu dominio para acceder a la plataforma',
  domainsAddButton: 'Añadir dominio',

  domainsInfoTitle: 'Dominio personalizado',
  domainsInfoDescription:
    'Configura un dominio personalizado para que tus empleados accedan desde tu propia URL. Por ejemplo:',

  domainsStatusVerified: 'Verificado',
  domainsStatusPending: 'Pendiente de verificación',
  domainsSslLabelPrefix: 'SSL:',
  domainsSslActive: 'Activo',
  domainsSslPending: 'Pendiente',

  domainsDnsRequiredTitle: 'Configuración DNS requerida',
  domainsDnsNameLabel: 'Nombre:',
  domainsDnsValueLabel: 'Valor:',
  domainsDnsCnameDescription: 'Apunta tu subdominio a nuestros servidores',
  domainsDnsTxtDescription: 'Verificación de propiedad del dominio',
  domainsDnsFooterText:
    'Tras configurar los registros DNS, haz clic en "Verificar" para completar la configuración. La propagación DNS puede tardar hasta 48 horas.',

  domainsEmptyTitle: 'No hay dominios configurados',
  domainsEmptySubtitle:
    'Añade un dominio personalizado para que tus empleados accedan a la plataforma con tu propia URL.',

  domainsFeatureSslTitle: 'SSL gratuito',
  domainsFeatureSslDescription:
    'Certificado SSL automático incluido para tu dominio',
  domainsFeatureWhiteLabelTitle: 'Marca blanca',
  domainsFeatureWhiteLabelDescription:
    'Tu marca, tu dominio, sin referencias a Rostafy',
  domainsFeatureCdnTitle: 'CDN global',
  domainsFeatureCdnDescription:
    'Distribución mundial para acceso rápido desde cualquier lugar',

  domainsModalTitle: 'Añadir dominio',
  domainsModalDomainLabel: 'Dominio',
  domainsModalDomainHelp:
    'Introduce el subdominio o dominio que quieres usar (sin https://)',
  domainsModalNoteText:
    'Después de añadir el dominio, debes configurar los registros DNS en tu proveedor de dominio.',
  domainsModalSubmitButton: 'Añadir',

  // Document Templates Page
  docTemplatesTitle: 'Plantillas de documentos',
  docTemplatesSubtitle:
    'Plantillas predefinidas por país, OCR para DNI/Pasaporte y autocompletado automático',
  docTemplatesOcrButton: 'Escanear DNI/Pasaporte',
  docTemplatesNewTemplateButton: 'Nueva plantilla',

  docTemplatesExtractedDataTitle: 'Datos extraídos automáticamente',
  docTemplatesExtractedDataLine:
    '{{count}} campos detectados - Selecciona una plantilla para usar estos datos',

  docTemplatesTabByCountry: 'Plantillas por país',
  docTemplatesTabMyTemplates: 'Mis plantillas',
  docTemplatesTabQuickGeneration: 'Generación rápida',

  docTemplatesNoCustomTitle: 'Sin plantillas personalizadas',
  docTemplatesNoCustomSubtitle:
    'Crea plantillas específicas para tu organización',
  docTemplatesCreateFirstButton: 'Crear primera plantilla',

  docTemplatesGenerateSuccess:
    'Documento generado y enviado para firma',
  docTemplatesCreateSuccess: 'Plantilla creada correctamente',
  docTemplatesOcrSuccess: 'Datos extraídos correctamente',

  docTemplatesCategoryEmploymentContract: 'Contrato',
  docTemplatesCategoryPolicy: 'Política',
  docTemplatesCategoryOther: 'Otros',
  docTemplatesCustomBadge: 'Personalizada',
  docTemplatesMoreFieldsBadge: '+{{count}} más',

  docTemplatesPreviewButton: 'Vista previa',
  docTemplatesGenerateButton: 'Generar',

  docTemplatesQuickTitle: 'Generación rápida con un clic',
  docTemplatesQuickDescription:
    'Selecciona un empleado y una plantilla. Los datos se autocompletarán automáticamente y el documento se enviará para firma.',
  docTemplatesQuickStepEmployee: '1. Seleccionar empleado',
  docTemplatesQuickEmployeePlaceholder: 'Elige empleado...',
  docTemplatesQuickStepTemplate: '2. Seleccionar plantilla',
  docTemplatesQuickTemplatePlaceholder: 'Elige plantilla...',
  docTemplatesQuickGenerateButton: 'Generar y enviar',
  docTemplatesQuickExtractedNote:
    'Se incluirán los datos extraídos del documento de identidad',
  docTemplatesRecentEmployeesTitle: 'Empleados recientes',
  docTemplatesQuickMissingSelection:
    'Selecciona empleado y plantilla',
  docTemplatesQuickSuccess:
    'Documento generado correctamente - Revisa en Firmas digitales',
  docTemplatesQuickError: 'Error al generar el documento',

  docTemplatesOcrTitle: 'Escanear documento de identidad',
  docTemplatesOcrDocumentTypeLabel: 'Tipo de documento',
  docTemplatesOcrDocTypeDni: 'DNI (España)',
  docTemplatesOcrDocTypeNie: 'NIE (España)',
  docTemplatesOcrDocTypePassport: 'Pasaporte',
  docTemplatesOcrDocTypeDriverLicense: 'Carnet de conducir',
  docTemplatesOcrCountryLabel: 'País del documento',
  docTemplatesOcrImageLabel: 'Imagen del documento',
  docTemplatesOcrUploadCta: 'Haz clic para subir una imagen',
  docTemplatesOcrNoteText:
    'Los datos se extraen automáticamente del documento. Revisa la información antes de generar contratos.',
  docTemplatesOcrExtractButton: 'Extraer datos',

  // Compliance Page
  complianceLoadError: 'Error al cargar los datos de cumplimiento',
  complianceReportError: 'Error al generar el informe',

  complianceTitle: 'Cumplimiento SOC 2',
  complianceSubtitle: 'Monitorización de seguridad y cumplimiento normativo',
  complianceGenerateReportButton: 'Generar informe',

  complianceScoreLabel: 'Puntuación de cumplimiento',
  complianceTwoFactorLabel: '2FA activada',
  complianceTwoFactorUsersLine:
    '{{enabled}}/{{total}} usuarios',
  complianceAuditEvents24hLabel: 'Eventos de auditoría (24h)',
  complianceOpenEventsLabel: 'Eventos abiertos',
  complianceCriticalEventsLine:
    '{{count}} críticos esta semana',

  complianceRecommendationsTitle: 'Recomendaciones',

  complianceTabSummary: 'Resumen',
  complianceTabAudit: 'Registros de auditoría',
  complianceTabSecurity: 'Eventos de seguridad',
  complianceTabAccess: 'Control de acceso',
  complianceTabRetention: 'Retención de datos',

  complianceAuditTitle: 'Registro de auditoría',
  complianceAuditDateHeader: 'Fecha',
  complianceAuditUserHeader: 'Usuario',
  complianceAuditActionHeader: 'Acción',
  complianceAuditResourceHeader: 'Recurso',
  complianceAuditIpHeader: 'IP',
  complianceAuditEmpty: 'No hay entradas de auditoría',

  complianceSecurityTitle: 'Eventos de seguridad',
  complianceSecurityEmpty: 'No hay eventos de seguridad',

  complianceAccessTitle: 'Matriz de control de acceso (RBAC)',
  complianceAccessResourceHeader: 'Recurso',

  complianceRetentionTitle: 'Políticas de retención de datos',
  complianceRetentionDays: '{{days}} días',

  complianceReportTitle: 'Informe de cumplimiento',

  // Compliance Alerts Page
  complianceAlertsTitle: 'Alertas de cumplimiento',
  complianceAlertsSubtitle:
    'Recibe notificaciones cuando los empleados estén por debajo del umbral de cumplimiento',
  complianceAlertsMainToggleTitle: 'Alertas automáticas',
  complianceAlertsDisabledSubtitle:
    'Las alertas automáticas están desactivadas',
  complianceAlertsFrequencyDaily: 'Recibirás alertas diarias',
  complianceAlertsFrequencyWeekly: 'Recibirás alertas semanales',
  complianceAlertsFrequencyBiweekly: 'Recibirás alertas quincenales',
  complianceAlertsFrequencyMonthly: 'Recibirás alertas mensuales',

  complianceAlertsSaveSuccess: 'Ajustes guardados',
  complianceAlertsSaveError: 'Error al guardar los ajustes',
  complianceAlertsEnabledMessage: 'Alertas activadas',
  complianceAlertsDisabledMessage: 'Alertas desactivadas',
  complianceAlertsSendError: 'Error al enviar la alerta',

  complianceAlertsLastAlertLine:
    'Última alerta: {{date}} ({{count}} empleado(s) por debajo de {{threshold}}%)',

  complianceAlertsThresholdTitle: 'Umbral de alerta',
  complianceAlertsThresholdLabel: 'Enviar alerta si el cumplimiento es inferior a:',
  complianceAlertsThresholdRecommended: 'Recomendado: 70%',
  complianceAlertsMinShiftsLabel: 'Turnos mínimos a considerar:',
  complianceAlertsMinShiftsOption1: '1 turno',
  complianceAlertsMinShiftsOption3: '3 turnos',
  complianceAlertsMinShiftsOption5: '5 turnos',
  complianceAlertsMinShiftsOption10: '10 turnos',
  complianceAlertsMinShiftsHelp:
    'Los empleados con menos turnos no se incluirán en las alertas',

  complianceAlertsFrequencyTitle: 'Frecuencia',
  complianceAlertsFrequencySendLabel: 'Enviar alertas:',
  complianceAlertsDayOfWeekLabel: 'Día de la semana:',
  complianceAlertsTimeOfDayLabel: 'Hora de envío:',

  complianceAlertsRecipientsTitle: 'Destinatarios',
  complianceAlertsOrgAdminsTitle: 'Administradores de la organización',
  complianceAlertsOrgAdminsSubtitle: 'Todos los administradores recibirán la alerta',
  complianceAlertsDeptManagersTitle: 'Responsables de departamento',
  complianceAlertsDeptManagersSubtitle:
    'Solo para empleados de su departamento',
  complianceAlertsAdditionalEmailsLabel: 'Correos adicionales:',
  complianceAlertsAdditionalEmailPlaceholder: 'email@ejemplo.com',

  complianceAlertsChannelsTitle: 'Canales de entrega',
  complianceAlertsChannelEmail: 'Correo',
  complianceAlertsChannelInApp: 'En la app',
  complianceAlertsChannelPush: 'Push',

  complianceAlertsContentTitle: 'Contenido de la alerta',
  complianceAlertsContentEmployeeDetailsLabel: 'Incluir detalles del empleado',
  complianceAlertsContentEmployeeDetailsDesc:
    'Nombre, departamento, tasa de cumplimiento',
  complianceAlertsContentTrendLabel:
    'Incluir comparación con el periodo anterior',
  complianceAlertsContentTrendDesc:
    'Mostrar si mejoró o empeoró',
  complianceAlertsContentRecommendationsLabel: 'Incluir recomendaciones',
  complianceAlertsContentRecommendationsDesc:
    'Sugerencias para mejorar el cumplimiento',

  complianceAlertsActionsTitle: 'Acciones',
  complianceAlertsActionsSubtitle:
    'Previsualiza o envía una alerta ahora',
  complianceAlertsPreviewButton: 'Vista previa',
  complianceAlertsSendNowButton: 'Enviar ahora',

  complianceAlertsPreviewTitle: 'Vista previa de alerta',
  complianceAlertsPreviewWouldSend:
    '⚠️ Se enviaría una alerta: {{count}} empleado(s) por debajo de {{threshold}}%',
  complianceAlertsPreviewWouldNotSend:
    '✅ No se enviaría ninguna alerta: Todos los empleados están dentro del umbral',
  complianceAlertsPreviewBelow: 'Por debajo del umbral',
  complianceAlertsPreviewAtRisk: 'En riesgo',
  complianceAlertsPreviewHealthy: 'Saludable',
  complianceAlertsPreviewEmployeesBelow:
    'Empleados por debajo de {{threshold}}%:',
  complianceAlertsPreviewNoDepartment: 'Sin departamento',
  complianceAlertsPreviewShiftsLine: '{{shifts}} turnos',
  complianceAlertsPreviewRecipientsLabel: 'Destinatarios:',

  // Calendar OAuth Settings Page
  calendarOAuthTitle: 'Integraciones de calendario (OAuth)',
  calendarOAuthSubtitle:
    'Configura credenciales OAuth para sincronización bidireccional de calendario',
  calendarOAuthInfoTitle: '¿Para qué sirve esto?',
  calendarOAuthInfoText:
    'Con OAuth, los empleados pueden conectar sus calendarios personales de Google o Microsoft para sincronización bidireccional. Los turnos se crean automáticamente en sus calendarios y los eventos personales pueden bloquear disponibilidad.',

  calendarOAuthSaveSuccess: 'Configuración guardada',
  calendarOAuthSaveError: 'Error al guardar la configuración',
  calendarOAuthTestSuccess: 'Conexión exitosa',
  calendarOAuthTestError: 'Error de conexión',

  calendarOAuthConnected: 'Conectado',
  calendarOAuthClientIdLabel: 'Client ID',
  calendarOAuthClientSecretLabel: 'Client Secret',

  calendarOAuthGoogleTitle: 'Google Calendar',
  calendarOAuthGoogleSubtitle: 'Sincronizar con cuentas de Google Workspace',
  calendarOAuthGoogleRedirectLabel:
    'URL de redirección (URI de redirección autorizado):',
  calendarOAuthTestConnectionButton: 'Probar conexión',
  calendarOAuthGoogleConsoleLink: 'Google Cloud Console',

  calendarOAuthMicrosoftTitle: 'Microsoft Outlook',
  calendarOAuthMicrosoftSubtitle: 'Sincronizar con Microsoft 365 y Outlook',
  calendarOAuthMicrosoftAppIdLabel: 'ID de la aplicación (cliente)',
  calendarOAuthTenantIdLabel: 'Tenant ID (opcional)',
  calendarOAuthTenantHelp:
    'Usa common para permitir cualquier cuenta, o especifica tu tenant para restringir',
  calendarOAuthMicrosoftRedirectLabel:
    'URL de redirección (URI de redirección):',
  calendarOAuthAzurePortalLink: 'Azure Portal',

  calendarOAuthInstructionsTitle: 'Instrucciones de configuración',
  calendarOAuthInstructionsGoogleStep1: '1. Ve a',
  calendarOAuthInstructionsGoogleStep2:
    '2. Crea un nuevo proyecto o selecciona uno existente',
  calendarOAuthInstructionsGoogleStep3:
    '3. Habilita la API de Google Calendar',
  calendarOAuthInstructionsGoogleStep4:
    '4. Ve a Credenciales → Crear credenciales → ID de cliente OAuth',
  calendarOAuthInstructionsGoogleStep5:
    '5. Configura la pantalla de consentimiento',
  calendarOAuthInstructionsGoogleStep6:
    '6. Añade el URI de redirección mostrado arriba',
  calendarOAuthInstructionsGoogleStep7:
    '7. Copia aquí el Client ID y el Client Secret',

  calendarOAuthInstructionsMicrosoftStep1: '1. Ve a',
  calendarOAuthInstructionsMicrosoftStep2:
    '2. Azure Active Directory → Registros de aplicaciones',
  calendarOAuthInstructionsMicrosoftStep3: '3. Nuevo registro',
  calendarOAuthInstructionsMicrosoftStep4:
    '4. Añade el URI de redirección mostrado arriba',
  calendarOAuthInstructionsMicrosoftStep5:
    '5. En Certificados y secretos, crea un nuevo secreto',
  calendarOAuthInstructionsMicrosoftStep6:
    '6. En Permisos de API, añade Calendars.ReadWrite',
  calendarOAuthInstructionsMicrosoftStep7:
    '7. Copia aquí el ID de aplicación y el secreto',

  // CRM Page
  crmTitle: 'CRM',
  crmSubtitle: 'Gestión de relaciones con clientes',
  crmLoadError: 'Error al cargar los datos del CRM',
  crmSaveError: 'Error al guardar el registro',
  crmMoveDealError: 'Error al mover el acuerdo',

  crmUpgradeTitle: 'CRM Premium',
  crmUpgradeDescription:
    'El módulo CRM requiere un plan Professional o superior para gestionar contactos y acuerdos.',
  crmUpgradeViewPlans: 'Ver planes',

  crmWsLive: 'En vivo',
  crmWsDisconnected: 'Desconectado',

  crmRealtimeTitle: 'Actividad en tiempo real',

  crmTabDashboard: 'Panel',
  crmTabContacts: 'Contactos',
  crmTabDeals: 'Acuerdos',
  crmTabPipeline: 'Pipeline',

  crmDashboardContactsLabel: 'Contactos',
  crmDashboardContactsLine: '{{leads}} leads, {{customers}} clientes',
  crmDashboardDealsLabel: 'Acuerdos',
  crmDashboardPipelineLabel: 'Pipeline',
  crmDashboardWonLabel: 'Ganados',

  crmSearchContactsPlaceholder: 'Buscar contactos...',
  crmFilterAllStatuses: 'Todos los estados',
  crmStatusLead: 'Lead',
  crmStatusQualified: 'Cualificado',
  crmStatusCustomer: 'Cliente',
  crmStatusChurned: 'Perdido',

  crmNoContacts: 'Sin contactos',
  crmCreateFirstContactButton: 'Crear primer contacto',
  crmNoDeals: 'Sin acuerdos',
  crmCreateFirstDealButton: 'Crear primer acuerdo',

  crmPipelineHint:
    'Arrastra acuerdos entre etapas para actualizar su estado',
  crmPipelineDropHere: 'Suelta aquí',
  crmPipelineNoDeals: 'Sin acuerdos',

  crmStageProspecting: 'Prospección',
  crmStageQualification: 'Cualificación',
  crmStageProposal: 'Propuesta',
  crmStageNegotiation: 'Negociación',
  crmStageWon: 'Ganado',
  crmStageLost: 'Perdido',

  crmNewContactButton: 'Nuevo contacto',
  crmNewDealButton: 'Nuevo acuerdo',

  crmModalNewContactTitle: 'Nuevo contacto',
  crmModalNewDealTitle: 'Nuevo acuerdo',
  crmModalContactNameLabel: 'Nombre *',
  crmModalContactCompanyLabel: 'Empresa',
  crmModalContactStatusLabel: 'Estado',
  crmModalDealNameLabel: 'Nombre del acuerdo *',
  crmModalDealValueLabel: 'Valor (€)',
  crmModalDealStageLabel: 'Etapa',
  crmModalDealProbabilityLabel: 'Probabilidad (%)',

  // Analytics Page
  analyticsTitle: 'Panel de analítica',
  analyticsSubtitle: 'Métricas y estadísticas para tu organización',
  analyticsNoData: 'Sin datos',

  analyticsPeriod7Days: 'Últimos 7 días',
  analyticsPeriod30Days: 'Últimos 30 días',
  analyticsPeriod90Days: 'Últimos 90 días',
  analyticsPeriod365Days: 'Último año',

  analyticsStatEmployeesActive: 'Empleados activos',
  analyticsStatTotalShifts: 'Turnos totales',
  analyticsStatShiftsAssigned: '{{percent}}% asignados',
  analyticsStatSwaps: 'Cambios',
  analyticsStatSwapsApproved: '{{percent}}% aprobados',
  analyticsStatHoursWorked: 'Horas trabajadas',
  analyticsStatHoursTotal: 'horas totales',

  analyticsWeeklyTrendsTitle: 'Tendencias semanales',
  analyticsSwapsByStatusTitle: 'Cambios por estado',
  analyticsHoursByEmployeeTitle: 'Horas por empleado',
  analyticsHoursByEmployeeEmpty: 'No hay datos de horas',
  analyticsTemplateUsageTitle: 'Uso de plantillas',
  analyticsTemplateUsageEmpty: 'Sin plantillas',

  analyticsRulesComplianceTitle: 'Reglas y cumplimiento',
  analyticsRulesActiveLabel: 'Reglas activas',
  analyticsRulesViolationsLabel: 'Infracciones',
  analyticsRulesComplianceRateLabel: 'Tasa de cumplimiento',

  analyticsDeploymentTitle: 'Panel listo para producción',
  analyticsDeploymentText:
    'Este panel está optimizado para desplegarse en AWS + Cloudflare. Las métricas se actualizan en tiempo real y soportan grandes volúmenes de datos.',

  // AI Scheduling Page
  aiSchedulingTitle: 'Programación con IA',
  aiSchedulingSubtitle: 'Optimización inteligente de turnos',

  aiSchedulingTabSuggest: 'Sugerencias',
  aiSchedulingTabAutoAssign: 'Autoasignar',
  aiSchedulingTabBalance: 'Equilibrio',
  aiSchedulingTabPredict: 'Predicción',
  aiSchedulingTabOptimize: 'Optimizar',

  aiSchedulingSuggestTitle: 'Obtener sugerencias',
  aiSchedulingSuggestDateLabel: 'Fecha',
  aiSchedulingSuggestPositionLabel: 'Puesto',
  aiSchedulingSuggestStartLabel: 'Inicio',
  aiSchedulingSuggestEndLabel: 'Fin',
  aiSchedulingSuggestButton: 'Obtener sugerencias',
  aiSchedulingSuggestEmpty:
    'Haz clic en "Obtener sugerencias" para ver recomendaciones',
  aiSchedulingSuggestedEmployeesTitle: 'Empleados sugeridos',
  aiSchedulingSuggestNonCompliant: 'No cumple todas las reglas',
  aiSchedulingSuggestError: 'Error al obtener sugerencias',

  aiSchedulingAutoAssignTitle: 'Autoasignación masiva',
  aiSchedulingAutoAssignInfo:
    'Esta función asignará automáticamente todos los turnos sin asignar en el rango de fechas seleccionado.',
  aiSchedulingAutoAssignButton: 'Ejecutar autoasignación',
  aiSchedulingAutoAssignResultTitle: 'Resultado',
  aiSchedulingAutoAssignTotalUnassigned: 'Total sin asignar',
  aiSchedulingAutoAssignAssigned: 'Asignados',
  aiSchedulingAutoAssignFailed: 'No asignados',
  aiSchedulingAutoAssignFailedShiftsTitle: 'Turnos sin asignar:',
  aiSchedulingAutoAssignSuccess:
    '{{count}} turnos asignados automáticamente',
  aiSchedulingAutoAssignError: 'Error durante la autoasignación',

  aiSchedulingBalanceTitle: 'Equilibrio de carga de trabajo',
  aiSchedulingBalanceEmployees: 'Empleados',
  aiSchedulingBalanceAverage: 'Media',
  aiSchedulingBalanceBalanced: 'Equilibrado',
  aiSchedulingBalanceVariance: 'Varianza',
  aiSchedulingBalanceOverworkedTitle: '⚠️ Sobrecargados',
  aiSchedulingBalanceUnderworkedTitle: '💡 Disponibles',
  aiSchedulingBalanceLoading: 'Cargando análisis...',
  aiSchedulingBalanceError: 'Error al analizar el equilibrio',

  aiSchedulingPredictTitle: 'Predicción de personal',
  aiSchedulingPredictDateLabel: 'Fecha a predecir',
  aiSchedulingPredictButton: 'Predecir necesidades',
  aiSchedulingPredictForDay: 'Predicción para {{day}}',
  aiSchedulingPredictShiftsRecommended: 'Turnos recomendados',
  aiSchedulingPredictAvgHistorical: 'Media histórica',
  aiSchedulingPredictTrendUp: '↑ En aumento',
  aiSchedulingPredictTrendDown: '↓ En descenso',
  aiSchedulingPredictTrendStable: '→ Estable',
  aiSchedulingPredictTrendLabel: 'Tendencia',
  aiSchedulingPredictConfidenceLabel: 'Confianza:',
  aiSchedulingPredictionError: 'Error durante la predicción',

  aiSchedulingOptimizeTitle: 'Optimizar horarios',
  aiSchedulingOptimizeButton: 'Analizar optimizaciones',
  aiSchedulingOptimizeSuggestionsTitle: 'Sugerencias de mejora',
  aiSchedulingOptimizeSuggestionsBadge: '{{count}} mejoras',
  aiSchedulingOptimizeCurrentScore: 'Actual: {{score}}%',
  aiSchedulingOptimizeSuggestedScore: 'Sugerido: {{score}}%',
  aiSchedulingOptimizeAlreadyOptimal: '¡Los horarios ya están optimizados!',
  aiSchedulingOptimizeSuccess:
    '{{count}} posibles mejoras encontradas',
  aiSchedulingOptimizeError: 'Error durante la optimización',

  // Advanced Analytics Page
  advancedAnalyticsTitle: 'Analítica avanzada',
  advancedAnalyticsSubtitle: 'Insights del sector, análisis ROI y predicciones',
  advancedAnalyticsGdprTitle: 'Cumplimiento GDPR/HIPAA:',
  advancedAnalyticsGdprText:
    'Toda la analítica usa solo datos anonimizados y agregados. No se comparte ni expone información personal.',
  advancedAnalyticsTabBenchmarking: 'Benchmarking del sector',
  advancedAnalyticsTabRoi: 'Calculadora de ROI',
  advancedAnalyticsTabTurnover: 'Predicción de rotación',
  advancedAnalyticsBenchmarkPercentileTitle: 'Tu percentil en el sector',
  advancedAnalyticsBenchmarkScoreTitle: 'Puntuación general',
  advancedAnalyticsBenchmarkComparedTo: 'Comparado con el promedio del sector {{industry}}',
  advancedAnalyticsBenchmarkYourValue: 'Tu valor',
  advancedAnalyticsBenchmarkIndustryAvg: 'Promedio del sector',
  advancedAnalyticsBenchmarkVsIndustry: 'vs sector',
  advancedAnalyticsRoiSavingsTitle: 'Tu ahorro anual estimado',
  advancedAnalyticsRoiText: 'Retorno de la inversión',
  advancedAnalyticsRoiWithoutTitle: 'Sin Rostafy',
  advancedAnalyticsRoiWithoutManagerTime: 'Tiempo del gestor planificando',
  advancedAnalyticsRoiWithoutSchedulingErrors: 'Errores de planificación',
  advancedAnalyticsRoiWithoutOvertimeCosts: 'Costes de horas extra',
  advancedAnalyticsRoiWithoutNoShowCosts: 'Costes por ausencias',
  advancedAnalyticsRoiTotalMonthly: 'Total mensual',
  advancedAnalyticsRoiWithTitle: 'Con Rostafy',
  advancedAnalyticsRoiWithSubscription: 'Suscripción',
  advancedAnalyticsRoiWithReducedOvertime: 'Reducción de horas extra',
  advancedAnalyticsRoiWithReducedNoShows: 'Reducción de ausencias',
  advancedAnalyticsRoiEfficiencyTitle: 'Ganancias de eficiencia',
  advancedAnalyticsRoiEfficiencySavedWeekly: 'Ahorro semanal',
  advancedAnalyticsRoiEfficiencyFewerErrors: 'Menos errores',
  advancedAnalyticsRoiEfficiencyLessOvertime: 'Menos horas extra',
  advancedAnalyticsRoiEfficiencyFewerNoShows: 'Menos ausencias',
  advancedAnalyticsTurnoverRetentionTitle: 'Puntuación de retención del equipo',
  advancedAnalyticsTurnoverTeamSize: 'Tamaño del equipo',
  advancedAnalyticsTurnoverHighRiskTitle: 'Empleados de alto riesgo',
  advancedAnalyticsTurnoverEmployees: 'empleados',
  advancedAnalyticsTurnoverEstimatedTitle: 'Rotación anual estimada',
  advancedAnalyticsTurnoverLikelyToLeave: 'empleados con probabilidad de irse',
  advancedAnalyticsTurnoverRiskTitle: 'Distribución del riesgo',
  advancedAnalyticsTurnoverRiskLow: 'Bajo',
  advancedAnalyticsTurnoverRiskModerate: 'Moderado',
  advancedAnalyticsTurnoverRiskHigh: 'Alto',
  advancedAnalyticsTurnoverPrivacyTitle: 'Aviso de privacidad:',

  // Missingkeys 1.0
  selectOrganization: 'Seleccionar organización',
  selectOrganizationToViewEmployees: 'Por favor, selecciona una organización para ver a los empleados',
  selectOrganizationToViewSettings: 'Por favor, selecciona una organización para ver la configuración',
  selectOrganizationToViewSettingsDescription: 'Selecciona una organización en el menú desplegable de arriba para ver y gestionar su configuración.',
  selectOrganizationToViewShifts: 'Por favor, selecciona una organización para ver los turnos',
  aiAssignment: 'Asignación con IA',
  settingsTabPassword: 'Contraseña',

  settingsSecurityProceedToDashboard: 'Ir al panel',
  copyAll: 'Copiar todo',
  copied: '¡Copiado!',

  enterBackupCode: 'Introduce uno de tus 8-caracteres backup codes',

  // Password subsection
  settingsPasswordTitle: 'Cambiar contraseña',
  settingsPasswordDescription: 'Actualiza la contraseña de inicio de sesión de esta cuenta.',
  settingsPasswordCurrentLabel: 'Contraseña actual',
  settingsPasswordNewLabel: 'Nueva contraseña',
  settingsPasswordConfirmLabel: 'Confirmar nueva contraseña',
  settingsPasswordHint: 'Usa al menos 12 caracteres, incluyendo letras, números y símbolos.',
  settingsPasswordRequired: 'Por favor, completa todos los campos de contraseña.',
  settingsPasswordMismatch: 'Las nuevas contraseñas no coinciden.',
  settingsPasswordSuccess: 'Tu contraseña se ha cambiado correctamente.',
  settingsPasswordError: 'Error al cambiar la contraseña',
  settingsPasswordSaveButton: 'Guardar contraseña',
  settingsPasswordChangeRequiredBannerTitle: 'Cambio de contraseña obligatorio',
  settingsPasswordChangeRequiredBannerText: 'Debes cambiar tu contraseña temporal antes de acceder al sistema. Por favor, cambia tu contraseña a continuación.',

  // Change Password Required Page
  changePasswordRequiredTitle: 'Cambia tu contraseña',
  changePasswordRequiredDescription: 'Debes cambiar tu contraseña temporal antes de acceder al sistema.',
  changePasswordRequiredNewPasswordLabel: 'Nueva contraseña',
  changePasswordRequiredNewPasswordPlaceholder: 'Introduce la nueva contraseña',
  changePasswordRequiredConfirmPasswordLabel: 'Confirmar nueva contraseña',
  changePasswordRequiredConfirmPasswordPlaceholder: 'Confirma la nueva contraseña',
  changePasswordRequiredSubmitButton: 'Cambiar contraseña',
  changePasswordRequiredSuccess: '¡Contraseña cambiada correctamente!',
  changePasswordRequiredError: 'No se pudo cambiar la contraseña. Por favor, inténtalo de nuevo.',
  changePasswordRequiredNewPasswordRequired: 'Por favor, introduce una nueva contraseña',
  changePasswordRequiredConfirmRequired: 'Por favor, confirma tu contraseña',
  changePasswordRequiredMismatch: 'Las contraseñas no coinciden',
  changePasswordRequiredWeakPassword: 'Por favor, corrige los errores de contraseña antes de enviar',
  changePasswordRequiredValidPassword: '✓ La contraseña cumple los requisitos',
  changePasswordRequiredPasswordsMatch: '✓ Las contraseñas coinciden',
  changePasswordRequiredSecurityNote: 'Por motivos de seguridad, debes cambiar tu contraseña temporal antes de acceder al sistema.',
  changePasswordRequiredMinLength: 'La contraseña debe tener al menos 12 caracteres',
  changePasswordRequiredUppercase: 'La contraseña debe contener al menos una letra mayúscula',
  changePasswordRequiredLowercase: 'La contraseña debe contener al menos una letra minúscula',
  changePasswordRequiredSpecialChar: 'La contraseña debe contener al menos un carácter especial',

  // 2FA required screen / admin banner
  settingsSecurityForce2faMessage: 'Tu organización requiere 2FA. Completa la configuración para continuar.',
  settingsSecurityForce2faIntro:
    'Haz clic en el botón de abajo para generar tu código QR de 2FA y escanéalo con tu app de autenticación.',
  settingsSecurityAdminBannerTitle: 'Tu organización exige 2FA para todos los usuarios.',
  settingsSecurityAdminBannerText:
    'Para máxima seguridad y para evitar escenarios de bloqueo, recomendamos encarecidamente habilitar 2FA también para tu propia cuenta de administrador.',
  settingsSecurityForce2faLabel: 'Exigir 2FA para todos los usuarios de esta organización',
  settingsSecurityForce2faDescription:
    'Cuando está habilitado, los usuarios no administradores (gerentes y trabajadores) deben configurar 2FA después de iniciar sesión antes de acceder al panel.',
  settingsSecurityForce2faEnabled: 'Se ha habilitado 2FA obligatorio para esta organización.',
  settingsSecurityForce2faDisabled: 'Se ha deshabilitado 2FA obligatorio para esta organización.',
  settingsSecurityForce2faError: 'Error al actualizar la configuración de 2FA obligatorio',




};
